<template>
  <div class="multiFilter-options-setting">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <rowColLayoutSize :options="options" :ids="ids" v-if="isInAutoLayout && curFilter === 0" />
        <template v-if="curFilter === 0">
          <el-collapse-item title="筛选项" name="1">
            <div v-if="!(!moreFilter && model !== 'filter') || model === 'tree'" class="navBox mb8" @click="changeFilter(1, true)">
              <span class="navTitle">一级分类</span>
              <span class="navLabel fs12">配置<i class="navIcon icon-portal-arrows-right"></i></span>
            </div>
            <div class="navBox" @click="changeFilter(2, true)">
              <span class="navTitle">子分类</span>
              <span class="navLabel fs12">配置<i class="navIcon icon-portal-arrows-right"></i></span>
            </div>
            <div v-if="model === 'filter'" class="navBox mt8" @click="changeFilter(3, true)">
              <span class="navTitle">已选标签</span>
              <span class="navLabel fs12">配置<i class="navIcon icon-portal-arrows-right"></i></span>
            </div>
            <!-- 展开收起按钮:样式1，样式3 -->
            <div v-if="moreFilter || model === 'tree'" class="navBox mt8" @click="changeFilter(8, true)">
              <span class="navTitle">展开收起按钮</span>
              <span class="navLabel fs12">配置<i class="navIcon icon-portal-arrows-right"></i></span>
            </div>
          </el-collapse-item>
          <!-- <widthAndHeightSize
            :widthAuto="false"
            :widthFull="true"
            :heightVal.sync="filterHeight"
            :heightFull.sync="filterHeightFull"
            :heightAuto.sync="filterHeightAuto"
            :disabledWidthAll="true"
            v-if="!isInAutoLayout"
          /> -->
          <el-collapse-item v-if="model === 'filter'" title="排列" name="2">
            <cx-slider
              label="对齐"
              :value.sync="filterAlignmentType"
              :options="alignmentTypeOptions"
              :showToolTip="true"
            />
            <div class="verticallyCenter mt12">
              <span class="fs14 mr16">间距</span>
              <div style="width: calc(100% - 44px)">
                <slider-and-input
                  inputWidth="small"
                  inputHeight="small"
                  :value.sync="filterMargin"
                  title=""
                  titlePosition="singleLine"
                  :sliderMax="100"
                  suffix="px"
                />
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item v-if="!model && moreFilter" title="排列" name="2">
            <cx-slider
              :showToolTip="false"
              label="方向"
              class="arrange-direction"
              :value.sync="arrangeType"
              :options="arrangeTypeOptions"
            />
            <div class="verticallyCenter mt12" v-if="!model && moreFilter">
              <span class="fs14 mr16">行间距</span>
              <div style="width: calc(100% - 60px)">
                <slider-and-input
                  class="flex1"
                  :value.sync="groupMargin"
                  :sliderMax="100"
                  suffix="px"
                  inputWidth="small"
                  inputHeight="small"
                />
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item title="背景" name="3">
            <cx-background infoTips="支持上传图片" :background.sync="background" imgType="10" />
          </el-collapse-item>
          <el-collapse-item title="边框" name="4">
            <div class="setting-item">
              <div class="content">
                <div>
                  <div class="content-item verticallyCenter mb12">
                    <el-checkbox v-model="filterShowBorder">显示边框</el-checkbox>
                  </div>
                  <cx-border
                    v-if="filterShowBorder"
                    :borderWidth.sync="borderWidth"
                    :borderStyle.sync="borderStyle"
                    :borderColor.sync="borderColor"
                    :borderIsThemeColor.sync="borderIsThemeColor"
                  />
                </div>
                <div class="content-item mt12">
                  <border-radius
                    :borderTypeFlag.sync="borderTypeFlag"
                    :borderRadius.sync="borderRadius"
                    :borderTopLeftRadius.sync="borderTopLeftRadius"
                    :borderTopRightRadius.sync="borderTopRightRadius"
                    :borderBottomRightRadius.sync="borderBottomRightRadius"
                    :borderBottomLeftRadius.sync="borderBottomLeftRadius"
                  />
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item title="边距" name="5">
            <div class="setting-item">
              <div class="content">
                <div class="content-item">
                  <cx-padding
                    :paddingTypeFlag.sync="paddingTypeFlag"
                    :padding.sync="padding"
                    :paddingTop.sync="paddingTop"
                    :paddingRight.sync="paddingRight"
                    :paddingBottom.sync="paddingBottom"
                    :paddingLeft.sync="paddingLeft"
                  />
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item title="更多" name="6">
            <div class="content">
              <div class="content-item mb16 verticallyCenter" v-if="(moreFilter && model) || model === 'tree'">
                <span class="fs14 mr16">行间距</span>
                <slider-and-input
                  class="flex1"
                  :value.sync="groupMargin"
                  :sliderMax="100"
                  suffix="px"
                  inputWidth="small"
                  inputHeight="small"
                />
              </div>
              <div class="verticallyCenter">
                <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
              </div>
              <div class="content-item mt12">
                <div class="checkbox_colorPicker_container">
                  <span>阴影</span>
                  <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('b')"></span>
                </div>
                <box-shadow
                  :boxShadowH.sync="boxShadowH"
                  :boxShadowV.sync="boxShadowV"
                  :boxShadowBlur.sync="boxShadowBlur"
                  :boxShadowSpread.sync="boxShadowSpread"
                  :boxShadowColor.sync="boxShadowColor"
                />
              </div>
              <div v-if="model === 'filter'" class="content-item verticallyCenter mt12">
                <el-checkbox class="" v-model="filterShowTabsScorll">开启横向滚动</el-checkbox>
              </div>
            </div>
          </el-collapse-item>
        </template>
        <template v-if="curFilter === 1 && (moreFilter || model === 'tree' || model === 'filter')">
          <div class="navBackBox" @click="changeFilter(0, false)">
            <i class="navBackIcon icon-portal-arrows-left"></i>
            <span class="navBackTitle">一级分类</span>
          </div>
          <cx-slider
            v-if="curFilter === 1 && model === 'filter'"
            class="rect-active-slider"
            label="状态"
            :value.sync="activeType"
            :options="activeTypeOptions"
          />
          <template v-if="activeType === '1'">
            <widthAndHeightSize
              v-if="model === 'filter'"
              :widthVal.sync="titleWidth"
              :heightVal.sync="titleHeight"
              :widthAuto.sync="titleWidthAuto"
              :heightAuto.sync="titleHeightAuto"
              :widthFull.sync="titleWidthFull"
              :disableWidthFull="false"
            />
            <widthAndHeightSize
              v-else
              :widthVal.sync="titleWidth"
              :heightVal.sync="titleHeight"
              :widthAuto.sync="titleWidthAuto"
              :heightAuto.sync="titleHeightAuto"
            />

            <el-collapse-item title="文字" name="1">
              <text-setting-complex-update
                :fontFamily.sync="titleFontFamily"
                :fontSize.sync="titleFontSize"
                :fontWeight.sync="titleFontWeight"
                :fontStyle.sync="titleFontStyle"
                :textDecoration.sync="titleTextDecoration"
                :lineHeight.sync="titleLineHeight"
                :lineHeightType.sync="titleLineHeightType"
                :letterSpacing.sync="titleLetterSpacing"
                :activeArrangement.sync="titleArrangement"
                :writingMode.sync="titleWritingMode"
                :textAlign.sync="titleTextAlign"
                :activeArrangementOrder.sync="titleArrangementOrder"
                :isThemeColor.sync="titleTextIsThemeColor"
                :colorArr.sync="titleColor"
                :showOverflowSetting="true"
                :contentHasLimit.sync="titleTextLimit"
                :contentHasLimitRadio.sync="titleContentHasLimitRadio"
                :overflowTypes="model === 'filter' ? overflowTypes1 : overflowTypes2"
                :textLimitLines.sync="titleTextLimitLines"
                :textLimitWords.sync="titleTextLimitCount"
                :options="options"
              />
            </el-collapse-item>
            <el-collapse-item title="背景" name="3">
              <cx-background infoTips="支持上传图片" :background.sync="titleBackground" imgType="10" />
            </el-collapse-item>
            <el-collapse-item v-if="model === 'filter'" title="图标" name="4">
              <el-checkbox v-model="titleTitleIconShow">显示图标</el-checkbox>
              <div class="content-item mt12" v-if="titleTitleIconShow">
                <img-icon-upload
                  class="mb16"
                  :imgSrc.sync="titleIconSrc"
                  :iconType.sync="titleIconType"
                  :iconColor.sync="titleIconColor"
                  :resInfo.sync="titleResInfo"
                />
                <div v-show="titleIconSrc.length" class="content-item mb16 verticallyCenter">
                  <span class="mr16 fs14">位置</span>
                  <el-radio-group v-model="titleIconPosition">
                    <el-radio label="left">左</el-radio>
                    <el-radio label="right">右</el-radio>
                  </el-radio-group>
                </div>
                <div class="verticallyCenter mb16" v-if="titleIconType === 'icon'">
                  <span class="mr16 fs14">颜色</span>
                  <cx-color-picker
                    class="flex1"
                    :isThemeColor.sync="titleIconColorIsThemeColor"
                    :colorArr.sync="titleIconColor"
                  />
                </div>
                <slider-and-input
                  class="mb16"
                  :value.sync="titleIconWidth"
                  title="大小"
                  :sliderMax="filterWidth"
                  suffix="px"
                />
                <slider-and-input :value.sync="titleIconMargin" title="间距" :sliderMax="filterWidth" suffix="px" />
              </div>
            </el-collapse-item>
            <el-collapse-item title="边框" name="5">
              <div>
                <div class="content-item verticallyCenter mb12">
                  <el-checkbox v-model="titleBorderShow">显示边框</el-checkbox>
                </div>
                <cx-border
                  v-if="titleBorderShow"
                  :borderWidth.sync="titleBorderWidth"
                  :borderStyle.sync="titleBorderStyle"
                  :borderColor.sync="titleBorderColor"
                  :borderIsThemeColor.sync="titleBorderIsThemeColor"
                />
              </div>
              <div class="content-item mt12">
                <border-radius
                  :borderTypeFlag.sync="titleBorderTypeFlag"
                  :borderRadius.sync="titleBorderRadius"
                  :borderTopLeftRadius.sync="titleBorderTopLeftRadius"
                  :borderTopRightRadius.sync="titleBorderTopRightRadius"
                  :borderBottomRightRadius.sync="titleBorderBottomRightRadius"
                  :borderBottomLeftRadius.sync="titleBorderBottomLeftRadius"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item title="边距" name="6">
              <cx-padding
                :paddingTypeFlag.sync="titlePaddingTypeFlag"
                :padding.sync="titlePadding"
                :paddingTop.sync="titlePaddingTop"
                :paddingRight.sync="titlePaddingRight"
                :paddingBottom.sync="titlePaddingBottom"
                :paddingLeft.sync="titlePaddingLeft"
              />
            </el-collapse-item>
            <el-collapse-item title="更多" name="7">
              <div class="content">
                <div class="verticallyCenter">
                  <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
                </div>
                <div class="content-item mt12">
                  <div class="checkbox_colorPicker_container">
                    <span>阴影</span>
                    <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('titleB')"></span>
                  </div>
                  <box-shadow
                    :boxShadowH.sync="titleBoxShadowH"
                    :boxShadowV.sync="titleBoxShadowV"
                    :boxShadowBlur.sync="titleBoxShadowBlur"
                    :boxShadowSpread.sync="titleBoxShadowSpread"
                    :boxShadowColor.sync="titleBoxShadowColor"
                  />
                </div>
                <div class="verticallyCenter mt12" v-if="model === 'filter'">
                  <cx-check-box :value.sync="openSelectedStatus">开启已选状态</cx-check-box>
                  <i class="tips-btn icon-portal-info2" @click="explainDialog = true"></i>
                </div>
              </div>
            </el-collapse-item>
          </template>
          <template v-if="activeType === '3'">
            <el-collapse-item title="文字" name="1">
              <text-setting-complex-update
                :fontFamily.sync="titleActiveFontFamily"
                :fontSize.sync="titleActiveFontSize"
                :fontWeight.sync="titleActiveFontWeight"
                :fontStyle.sync="titleActiveFontStyle"
                :textDecoration.sync="titleActiveTextDecoration"
                :lineHeight.sync="titleActiveLineHeight"
                :lineHeightType.sync="titleActiveLineHeightType"
                :letterSpacing.sync="titleActiveLetterSpacing"
                :activeArrangement.sync="titleActiveArrangement"
                :writingMode.sync="titleActiveWritingMode"
                :textAlign.sync="titleActiveTextAlign"
                :activeArrangementOrder.sync="titleActiveArrangementOrder"
                :isThemeColor.sync="titleActiveTextIsThemeColor"
                :colorArr.sync="titleActiveColor"
                :options="options"
              />
            </el-collapse-item>
            <el-collapse-item title="背景" name="3">
              <cx-background infoTips="支持上传图片" :background.sync="titleActiveBackground" imgType="10" />
            </el-collapse-item>
            <el-collapse-item v-if="model === 'filter'" title="图标" name="4">
              <el-checkbox v-model="titleActiveTitleIconShow">显示图标</el-checkbox>
              <div class="content-item mt12" v-if="titleActiveTitleIconShow">
                <img-icon-upload
                  class="mb16"
                  :imgSrc.sync="titleActiveIconSrc"
                  :iconType.sync="titleActiveIconType"
                  :iconColor.sync="titleActiveIconColor"
                  :resInfo.sync="titleActiveResInfo"
                />
                <div v-show="titleActiveIconSrc.length" class="content-item mb16 verticallyCenter">
                  <span class="mr16 fs14">位置</span>
                  <el-radio-group v-model="titleActiveIconPosition">
                    <el-radio label="left">左</el-radio>
                    <el-radio label="right">右</el-radio>
                  </el-radio-group>
                </div>
                <div class="verticallyCenter mb16" v-if="titleActiveIconType === 'icon'">
                  <span class="mr16 fs14">颜色</span>
                  <cx-color-picker
                    class="flex1"
                    :isThemeColor.sync="titleActiveIconColorIsThemeColor"
                    :colorArr.sync="titleActiveIconColor"
                  />
                </div>
                <slider-and-input
                  class="mb16"
                  :value.sync="titleActiveIconWidth"
                  title="大小"
                  :sliderMax="filterWidth"
                  suffix="px"
                />
                <slider-and-input
                  :value.sync="titleActiveIconMargin"
                  title="间距"
                  :sliderMax="filterWidth"
                  suffix="px"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item v-if="model === 'filter'" title="边框" name="5">
              <div>
                <div class="content-item verticallyCenter mb12">
                  <el-checkbox v-model="titleActiveBorderShow">显示边框</el-checkbox>
                </div>
                <cx-border
                  v-if="titleActiveBorderShow"
                  :borderWidth.sync="titleActiveBorderWidth"
                  :borderStyle.sync="titleActiveBorderStyle"
                  :borderColor.sync="titleActiveBorderColor"
                  :borderIsThemeColor.sync="titleActiveBorderIsThemeColor"
                />
              </div>
              <div class="content-item mt12">
                <border-radius
                  :borderTypeFlag.sync="titleActiveBorderTypeFlag"
                  :borderRadius.sync="titleActiveBorderRadius"
                  :borderTopLeftRadius.sync="titleActiveBorderTopLeftRadius"
                  :borderTopRightRadius.sync="titleActiveBorderTopRightRadius"
                  :borderBottomRightRadius.sync="titleActiveBorderBottomRightRadius"
                  :borderBottomLeftRadius.sync="titleActiveBorderBottomLeftRadius"
                />
              </div>
            </el-collapse-item>
          </template>
        </template>
        <template v-if="curFilter === 2">
          <div class="navBackBox" @click="changeFilter(0, false)">
            <i class="navBackIcon icon-portal-arrows-left"></i>
            <span class="navBackTitle">子分类</span>
          </div>
          <CustomSubMenuSetting
            v-if="model === 'filter'"
            :currentSetStyle.sync="currentSetStyle"
            :currentSetMenu.sync="currentSetMenu"
            :subMenuConfig.sync="subMenuConfig"
            :rectId="ids.rect_id"
            :options="options"
          ></CustomSubMenuSetting>
          <template v-if="model === 'filter'">
            <el-collapse-item title="分类项" name="3">
              <div class="navBox" @click="changeFilter(5, true)">
                <span class="navTitle">分类项</span>
                <span class="navLabel fs12">配置<i class="navIcon icon-portal-arrows-right"></i></span>
              </div>
            </el-collapse-item>
            <widthAndHeightSize
              :disabledWidthAll="true"
              :widthAuto="false"
              :widthFull="true"
              :heightVal.sync="subFilterHeight"
              :heightAuto.sync="subFilterHeightAuto"
              :showMinMax="false"
              :showMinMaxHeight="true"
              :showMinWidth1="false"
              :showMaxWidth1="false"
              :showMinHeight1.sync="subFilterShowMinHeight"
              :showMaxHeight1.sync="subFilterShowMaxHeight"
              :minHeight1.sync="subFilterMinHeightVal"
              :maxHeight1.sync="subFilterMaxHeightVal"
            />
            <el-collapse-item title="排列" name="4">
              <div class="verticallyCenter row-set">
                <span class="fs14 mr16 keep-all">列数</span>
                <single-input style="width: 104px" :value.sync="menuRowContent" :noInputSuffixs="true" :min="1" />
                <div class="btn-wrapper">
                  <span
                    :class="menuRowContent === 1 ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
                    @click="changeRowLen(0)"
                  ></span>
                  <span
                    :class="menuRowContent === 10 ? 'disabled num-btn icon-portal-plus' : 'num-btn icon-portal-plus'"
                    class="num-btn icon-portal-plus"
                    @click="changeRowLen(1)"
                  ></span>
                </div>
              </div>
              <div class="content-item mt12 verticallyTop">
                <span class="mr16 mt6">间距</span>
                <div class="content-item mr8 flex1">
                  <single-input :value.sync="lineMargin" inputSuffixs="px" />
                  <p class="fs12 mt8 ml12 setting-item-txt">行间距</p>
                </div>
                <div class="content-item flex1">
                  <single-input :value.sync="columnMargin" inputSuffixs="px" />
                  <p class="fs12 mt8 ml12 setting-item-txt">列间距</p>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="背景" name="5">
              <cx-background infoTips="支持上传图片" :background.sync="subFilterBackground" imgType="10" />
            </el-collapse-item>
            <el-collapse-item title="边框" name="6">
              <div class="setting-item">
                <div class="content">
                  <div>
                    <div class="content-item verticallyCenter mb12">
                      <el-checkbox v-model="subFilterShowBorder">显示边框</el-checkbox>
                    </div>
                    <cx-border
                      v-if="subFilterShowBorder"
                      :borderWidth.sync="subFilterBorderWidth"
                      :borderStyle.sync="subFilterBorderStyle"
                      :borderColor.sync="subFilterBorderColor"
                      :borderIsThemeColor.sync="subFilterBorderIsThemeColor"
                    />
                  </div>
                  <div class="content-item mt12">
                    <border-radius
                      :borderTypeFlag.sync="subFilterBorderTypeFlag"
                      :borderRadius.sync="subFilterBorderRadius"
                      :borderTopLeftRadius.sync="subFilterBorderTopLeftRadius"
                      :borderTopRightRadius.sync="subFilterBorderTopRightRadius"
                      :borderBottomRightRadius.sync="subFilterBorderBottomRightRadius"
                      :borderBottomLeftRadius.sync="subFilterBorderBottomLeftRadius"
                    />
                  </div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="边距" name="7">
              <div class="setting-item">
                <div class="content">
                  <div class="content-item">
                    <cx-padding
                      :paddingTypeFlag.sync="subFilterPaddingTypeFlag"
                      :padding.sync="subFilterPadding"
                      :paddingTop.sync="subFilterPaddingTop"
                      :paddingRight.sync="subFilterPaddingRight"
                      :paddingBottom.sync="subFilterPaddingBottom"
                      :paddingLeft.sync="subFilterPaddingLeft"
                    />
                  </div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="背景遮罩" name="8">
              <cx-background infoTips="支持上传图片" :background.sync="subFilterDialogBackground" imgType="10" />
            </el-collapse-item>
            <el-collapse-item title="筛选方式" name="9">
              <cx-slider
                :value.sync="filterType"
                :options="filterTypeOptions"
              />
              <div class="content-item mt12" v-if="filterType === '2'">
                <span class="fs14">底部栏高度</span>
                <slider-and-input
                  class="mt12"
                  inputWidth="small"
                  inputHeight="small"
                  :value.sync="filterBottomHeight"
                  title=""
                  titlePosition="singleLine"
                  :sliderMax="500"
                  suffix="px"
                />
                <div class="content-item mt12">
                  <el-checkbox v-model="openResetButton"
                    >开启重置按钮<i class="tips-btn icon-portal-info2"></i
                  ></el-checkbox>
                </div>
                <div class="navBox mt12" @click="changeFilter(6, true)">
                  <span class="navTitle">确定按钮</span>
                  <span class="navLabel fs12">配置<i class="navIcon icon-portal-arrows-right"></i></span>
                </div>
                <div class="navBox mt12" v-if="openResetButton" @click="changeFilter(7, true)">
                  <span class="navTitle">重置按钮</span>
                  <span class="navLabel fs12">配置<i class="navIcon icon-portal-arrows-right"></i></span>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="更多" name="10">
              <div class="content">
                <div class="verticallyCenter">
                  <slider-and-input :value.sync="subFilterOpacity" title="透明度" :sliderMax="100" suffix="%" />
                </div>
                <div class="content-item mt12">
                  <div class="checkbox_colorPicker_container">
                    <span>阴影</span>
                    <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('subFilterB')"></span>
                  </div>
                  <box-shadow
                    :boxShadowH.sync="subFilterBoxShadowH"
                    :boxShadowV.sync="subFilterBoxShadowV"
                    :boxShadowBlur.sync="subFilterBoxShadowBlur"
                    :boxShadowSpread.sync="subFilterBoxShadowSpread"
                    :boxShadowColor.sync="subFilterBoxShadowColor"
                  />
                </div>
              </div>
            </el-collapse-item>
          </template>
        </template>

        <template v-if="curFilter === 3 && model === 'filter'">
          <div class="navBackBox" @click="changeFilter(0, false)">
            <i class="navBackIcon icon-portal-arrows-left"></i>
            <span class="navBackTitle">已选标签</span>
          </div>
          <div class="content-item verticallyCenter checked-label">
            <el-checkbox v-model="labelShow">显示已选项标签</el-checkbox>
            <i class="tips-btn icon-portal-info2"></i>
          </div>
          <template v-if="labelShow">
            <el-collapse-item title="已选项" name="1">
              <div class="navBox" @click="changeFilter(4, true)">
                <span class="navTitle">已选项</span>
                <span class="navLabel fs12">配置<i class="navIcon icon-portal-arrows-right"></i></span>
              </div>
            </el-collapse-item>
            <widthAndHeightSize
              :widthAuto="false"
              :widthFull="true"
              :heightVal.sync="labelBoxHeight"
              :heightAuto.sync="labelBoxHeightAuto"
              :disabledWidthAll="true"
            />
            <el-collapse-item title="排列" name="2">
              <cx-slider
                label="对齐"
                :value.sync="labelAlignmentType"
                :options="alignmentTypeOptions"
                :showToolTip="true"
              />
              <div class="content-item mt12 verticallyTop">
                <span class="mr16 mt6">间距</span>
                <div class="content-item mr8 flex1">
                  <single-input :value.sync="labelLineMargin" inputSuffixs="px" />
                  <p class="fs12 mt8 ml12 setting-item-txt">行间距</p>
                </div>
                <div class="content-item flex1">
                  <single-input :value.sync="labelColumnMargin" inputSuffixs="px" />
                  <p class="fs12 mt8 ml12 setting-item-txt">列间距</p>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="背景" name="3">
              <cx-background infoTips="支持上传图片" :background.sync="labelBoxBackground" imgType="10" />
            </el-collapse-item>
            <el-collapse-item title="边框" name="4">
              <div class="setting-item">
                <div class="content">
                  <div>
                    <div class="content-item verticallyCenter mb12">
                      <el-checkbox v-model="labelBoxShowBorder">显示边框</el-checkbox>
                    </div>
                    <cx-border
                      v-if="labelBoxShowBorder"
                      :borderWidth.sync="labelBoxBorderWidth"
                      :borderStyle.sync="labelBoxBorderStyle"
                      :borderColor.sync="labelBoxBorderColor"
                      :borderIsThemeColor.sync="labelBoxBorderIsThemeColor"
                    />
                  </div>
                  <div class="content-item mt12">
                    <border-radius
                      :borderTypeFlag.sync="labelBoxBorderTypeFlag"
                      :borderRadius.sync="labelBoxBorderRadius"
                      :borderTopLeftRadius.sync="labelBoxBorderTopLeftRadius"
                      :borderTopRightRadius.sync="labelBoxBorderTopRightRadius"
                      :borderBottomRightRadius.sync="labelBoxBorderBottomRightRadius"
                      :borderBottomLeftRadius.sync="labelBoxBorderBottomLeftRadius"
                    />
                  </div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="边距" name="5">
              <div class="setting-item">
                <div class="content">
                  <div class="content-item">
                    <cx-padding
                      :paddingTypeFlag.sync="labelBoxPaddingTypeFlag"
                      :padding.sync="labelBoxPadding"
                      :paddingTop.sync="labelBoxPaddingTop"
                      :paddingRight.sync="labelBoxPaddingRight"
                      :paddingBottom.sync="labelBoxPaddingBottom"
                      :paddingLeft.sync="labelBoxPaddingLeft"
                    />
                  </div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="更多" name="6">
              <div class="content">
                <div class="verticallyCenter">
                  <slider-and-input :value.sync="labelBoxOpacity" title="透明度" :sliderMax="100" suffix="%" />
                </div>
                <div class="content-item mt12">
                  <div class="checkbox_colorPicker_container">
                    <span>阴影</span>
                    <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('labelBoxB')"></span>
                  </div>
                  <box-shadow
                    :boxShadowH.sync="labelBoxBoxShadowH"
                    :boxShadowV.sync="labelBoxBoxShadowV"
                    :boxShadowBlur.sync="labelBoxBoxShadowBlur"
                    :boxShadowSpread.sync="labelBoxBoxShadowSpread"
                    :boxShadowColor.sync="labelBoxBoxShadowColor"
                  />
                </div>
                <div class="content-item verticallyCenter mt12">
                  <el-checkbox class="" v-model="showLabelScorll">开启横向滚动</el-checkbox>
                </div>
              </div>
            </el-collapse-item>
          </template>
        </template>
        <template v-if="curFilter === 4 && model === 'filter'">
          <div class="navBackBox" @click="changeFilter(3, true)">
            <i class="navBackIcon icon-portal-arrows-left"></i>
            <span class="navBackTitle">已选项</span>
          </div>
          <widthAndHeightSize
            :widthVal.sync="labelWidth"
            :heightVal.sync="labelHeight"
            :widthAuto.sync="labelWidthAuto"
            :heightAuto.sync="labelHeightAuto"
          />
          <el-collapse-item title="文字" name="1">
            <text-setting-complex-update
              :fontFamily.sync="labelFontFamily"
              :fontSize.sync="labelFontSize"
              :fontWeight.sync="labelFontWeight"
              :fontStyle.sync="labelFontStyle"
              :textDecoration.sync="labelTextDecoration"
              :lineHeight.sync="labelLineHeight"
              :lineHeightType.sync="labelLineHeightType"
              :letterSpacing.sync="labelLetterSpacing"
              :activeArrangement.sync="labelArrangement"
              :writingMode.sync="labelWritingMode"
              :textAlign.sync="labelTextAlign"
              :activeArrangementOrder.sync="labelArrangementOrder"
              :isThemeColor.sync="labelTextIsThemeColor"
              :colorArr.sync="labelColor"
              :showOverflowSetting="true"
              :contentHasLimit.sync="labelContentHasLimit"
              :contentHasLimitRadio="'字数'"
              :overflowTypes="['字数', '无']"
              :textLimitWords.sync="labelTextLimitWords"
              :options="options"
            />
          </el-collapse-item>
          <el-collapse-item title="图标" name="2">
            <div class="content-item">
              <img-icon-upload
                class="mb16"
                :imgSrc.sync="labelIconSrc"
                :iconType.sync="labelIconType"
                :iconColor.sync="labelIconColor"
                :resInfo.sync="labelResInfo"
              />
              <div v-show="labelIconSrc.length" class="content-item mb16 verticallyCenter">
                <span class="mr16 fs14">位置</span>
                <el-radio-group v-model="labelIconPosition">
                  <el-radio label="top">上</el-radio>
                  <el-radio label="bottom">下</el-radio>
                  <el-radio label="left">左</el-radio>
                  <el-radio label="right">右</el-radio>
                </el-radio-group>
              </div>
              <div class="verticallyCenter mb16" v-if="labelIconType === 'icon'">
                <span class="mr16 fs14">颜色</span>
                <cx-color-picker
                  class="flex1"
                  :isThemeColor.sync="labelIconColorIsThemeColor"
                  :colorArr.sync="labelIconColor"
                />
              </div>
              <slider-and-input
                class="mb16"
                :value.sync="labelIconWidth"
                title="大小"
                :sliderMax="filterWidth"
                suffix="px"
              />
              <slider-and-input :value.sync="labelIconMargin" title="间距" :sliderMax="filterWidth" suffix="px" />
            </div>
          </el-collapse-item>
          <el-collapse-item title="背景" name="3">
            <cx-background infoTips="支持上传图片" :background.sync="labelBackground" imgType="10" />
          </el-collapse-item>
          <el-collapse-item title="边框" name="4">
            <div>
              <div class="content-item verticallyCenter mb12">
                <el-checkbox v-model="labelShowBorder">显示边框</el-checkbox>
              </div>
              <cx-border
                v-if="labelShowBorder"
                :borderWidth.sync="labelBorderWidth"
                :borderStyle.sync="labelBorderStyle"
                :borderColor.sync="labelBorderColor"
                :borderIsThemeColor.sync="labelBorderIsThemeColor"
              />
            </div>
            <div class="content-item mt12">
              <border-radius
                :borderTypeFlag.sync="labelBorderTypeFlag"
                :borderRadius.sync="labelBorderRadius"
                :borderTopLeftRadius.sync="labelBorderTopLeftRadius"
                :borderTopRightRadius.sync="labelBorderTopRightRadius"
                :borderBottomRightRadius.sync="labelBorderBottomRightRadius"
                :borderBottomLeftRadius.sync="labelBorderBottomLeftRadius"
              />
            </div>
          </el-collapse-item>
          <el-collapse-item title="边距" name="5">
            <cx-padding
              :paddingTypeFlag.sync="labelPaddingTypeFlag"
              :padding.sync="labelPadding"
              :paddingTop.sync="labelPaddingTop"
              :paddingRight.sync="labelPaddingRight"
              :paddingBottom.sync="labelPaddingBottom"
              :paddingLeft.sync="labelPaddingLeft"
            />
          </el-collapse-item>
          <el-collapse-item title="更多" name="6">
            <div class="content">
              <div class="verticallyCenter">
                <slider-and-input :value.sync="labelOpacity" title="透明度" :sliderMax="100" suffix="%" />
              </div>
              <div class="content-item mt12">
                <div class="checkbox_colorPicker_container">
                  <span>阴影</span>
                  <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('labelB')"></span>
                </div>
                <box-shadow
                  :boxShadowH.sync="labelBoxShadowH"
                  :boxShadowV.sync="labelBoxShadowV"
                  :boxShadowBlur.sync="labelBoxShadowBlur"
                  :boxShadowSpread.sync="labelBoxShadowSpread"
                  :boxShadowColor.sync="labelBoxShadowColor"
                />
              </div>
            </div>
          </el-collapse-item>
        </template>
        <template v-if="curFilter === 2 && model !== 'filter' || curFilter === 5">
          <div class="navBackBox" @click="changeFilter(2, true)" v-if="curFilter === 5">
            <i class="navBackIcon icon-portal-arrows-left"></i>
            <span class="navBackTitle">分类项</span>
          </div>
          <cx-slider class="rect-active-slider" label="状态" :value.sync="subActiveType" :options="model === 'filter' ? activeTypeOptions : subActiveTypeOptions" />
          <template v-if="subActiveType === '1'">
            <widthAndHeightSize
              v-if="curFilter === 5"
              :widthVal.sync="subMenuWidth"
              :widthAuto.sync="subMenuWidthAuto"
              :heightVal.sync="subMenuHeight"
              :heightAuto.sync="subMenuHeightAuto"
            />
            <widthAndHeightSize
              v-else
              :widthVal.sync="subMenuWidth"
              :widthAuto.sync="subMenuWidthAuto"
              :heightVal.sync="subMenuHeight"
              :heightAuto.sync="subMenuHeightAuto"
              :widthFull.sync="subMenuWidthFull"
              :disableWidthFull="false"
            />
            <el-collapse-item title="文字" name="1">
              <text-setting-complex-update
                  :fontFamily.sync="fontFamily"
                  :fontSize.sync="fontSize"
                  :fontWeight.sync="fontWeight"
                  :fontStyle.sync="fontStyle"
                  :textDecoration.sync="textDecoration"
                  :lineHeight.sync="lineHeight"
                  :lineHeightType.sync="lineHeightType"
                  :letterSpacing.sync="letterSpacing"
                  :activeArrangement.sync="activeArrangement"
                  :writingMode.sync="writingMode"
                  :textAlign.sync="textAlign"
                  :activeArrangementOrder.sync="activeArrangementOrder"
                  :isThemeColor.sync="textIsThemeColor"
                  :colorArr.sync="color"
                  :showOverflowSetting="true"
                  :contentHasLimit.sync="contentHasLimit"
                  :contentHasLimitRadio.sync="contentHasLimitRadio"
                  :overflowTypes="model === 'filter' ? overflowTypes1 : overflowTypes2"
                  :textLimitLines.sync="textLimitLines"
                  :textLimitWords.sync="textLimitWords"
                  :options="options"
              />
            </el-collapse-item>
            <el-collapse-item title="背景" name="2">
              <cx-background infoTips="支持上传图片" :background.sync="defaultBackground" imgType="10" />
            </el-collapse-item>
            <el-collapse-item title="图标" name="3" v-if="model === 'filter'">
              <el-checkbox v-model="showDefaultIcon">显示图标</el-checkbox>
              <div class="content-item mt12" v-if="showDefaultIcon">
                <img-icon-upload
                  class="mb16"
                  :imgSrc.sync="defaultIconSrc"
                  :iconType.sync="defaultIconType"
                  :iconColor.sync="defaultIconColor"
                  :resInfo.sync="defaultResInfo"
                />
                <div v-show="defaultIconSrc.length" class="content-item mb16 verticallyCenter">
                  <span class="mr16 fs14">位置</span>
                  <el-radio-group v-model="defaultIconPosition">
                    <el-radio label="top">上</el-radio>
                    <el-radio label="bottom">下</el-radio>
                    <el-radio label="left">左</el-radio>
                    <el-radio label="right">右</el-radio>
                  </el-radio-group>
                </div>
                <div class="verticallyCenter mb16" v-if="defaultIconType === 'icon'">
                  <span class="mr16 fs14">颜色</span>
                  <cx-color-picker
                    class="flex1"
                    :isThemeColor.sync="defaultIconColorIsThemeColor"
                    :colorArr.sync="defaultIconColor"
                  />
                </div>
                <slider-and-input
                  class="mb16"
                  :value.sync="defaultIconWidth"
                  title="大小"
                  :sliderMax="filterWidth"
                  suffix="px"
                />
                <slider-and-input :value.sync="defaultIconMargin" title="间距" :sliderMax="filterWidth" suffix="px" />
              </div>
            </el-collapse-item>
            <el-collapse-item title="边框" name="4">
              <div>
                <div class="content-item verticallyCenter mb12">
                  <el-checkbox v-model="defaultShowBorder">显示边框</el-checkbox>
                </div>
                <cx-border
                  v-if="defaultShowBorder"
                  :borderWidth.sync="defaultBorderWidth"
                  :borderStyle.sync="defaultBorderStyle"
                  :borderColor.sync="defaultBorderColor"
                  :borderIsThemeColor.sync="defaultBorderIsThemeColor"
                />
              </div>
              <div class="content-item mt12">
                <border-radius
                  :borderTypeFlag.sync="defaultBorderTypeFlag"
                  :borderRadius.sync="defaultBorderRadius"
                  :borderTopLeftRadius.sync="defaultBorderTopLeftRadius"
                  :borderTopRightRadius.sync="defaultBorderTopRightRadius"
                  :borderBottomRightRadius.sync="defaultBorderBottomRightRadius"
                  :borderBottomLeftRadius.sync="defaultBorderBottomLeftRadius"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item title="边距" name="5">
              <cx-padding
                :paddingTypeFlag.sync="defaultPaddingTypeFlag"
                :padding.sync="defaultPadding"
                :paddingTop.sync="defaultPaddingTop"
                :paddingRight.sync="defaultPaddingRight"
                :paddingBottom.sync="defaultPaddingBottom"
                :paddingLeft.sync="defaultPaddingLeft"
              />
            </el-collapse-item>
            <el-collapse-item title="更多" name="6">
              <div class="content">
                <div class="verticallyCenter">
                  <slider-and-input :value.sync="defaultOpacity" title="透明度" :sliderMax="100" suffix="%" />
                </div>
                <div class="content-item mt12 verticallyTop" v-if="model !== 'filter'">
                  <span class="mr8 mt6">间距</span>
                  <div class="content-item mr8 flex1">
                    <single-input :value.sync="lineMargin" inputSuffixs="px" />
                    <p class="fs12 mt8 ml12 setting-item-txt">行间距</p>
                  </div>
                  <div class="content-item flex1">
                    <single-input :value.sync="columnMargin" inputSuffixs="px" />
                    <p class="fs12 mt8 ml12 setting-item-txt">列间距</p>
                  </div>
                </div>
                <div class="content-item mt12">
                  <div class="checkbox_colorPicker_container">
                    <span>阴影</span>
                    <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('defaultB')"></span>
                  </div>
                  <box-shadow
                    :boxShadowH.sync="defaultBoxShadowH"
                    :boxShadowV.sync="defaultBoxShadowV"
                    :boxShadowBlur.sync="defaultBoxShadowBlur"
                    :boxShadowSpread.sync="defaultBoxShadowSpread"
                    :boxShadowColor.sync="defaultBoxShadowColor"
                  />
                </div>
              </div>
            </el-collapse-item>
          </template>
          <template v-if="subActiveType === '2'">
            <el-collapse-item title="文字" name="1">
              <text-setting-complex-update
                :fontFamily.sync="hoverFontFamily"
                :fontSize.sync="hoverFontSize"
                :fontWeight.sync="hoverFontWeight"
                :fontStyle.sync="hoverFontStyle"
                :textDecoration.sync="hoverTextDecoration"
                :lineHeight.sync="hoverLineHeight"
                :lineHeightType.sync="hoverLineHeightType"
                :letterSpacing.sync="hoverLetterSpacing"
                :activeArrangement.sync="activeArrangement"
                :writingMode.sync="writingMode"
                :textAlign.sync="textAlign"
                :activeArrangementOrder.sync="activeArrangementOrder"
                :isThemeColor.sync="hoverColorIsThemeColor"
                :colorArr.sync="hoverColor"
                :showOverflowSetting="false"
                :options="options"
              />
            </el-collapse-item>
            <el-collapse-item title="背景" name="2">
              <cx-background infoTips="支持上传图片" :background.sync="hoverBackground" imgType="10" />
            </el-collapse-item>
            <!-- <el-collapse-item title="图标" name="3">
              <el-checkbox v-model="showHoverIcon">显示图标</el-checkbox>
              <div class="content-item mt12" v-if="showHoverIcon">
                <img-icon-upload
                  class="mb16"
                  :imgSrc.sync="hoverIconSrc"
                  :iconType.sync="hoverIconType"
                  :iconColor.sync="hoverIconColor"
                  :resInfo.sync="hoverResInfo"
                />
                <div v-show="hoverIconSrc.length" class="content-item mb16 verticallyCenter">
                  <span class="mr16 fs14">位置</span>
                  <el-radio-group v-model="hoverIconPosition">
                    <el-radio label="left">左</el-radio>
                    <el-radio label="right">右</el-radio>
                  </el-radio-group>
                </div>
                <div class="verticallyCenter mb16" v-if="hoverIconType === 'icon'">
                  <span class="mr16 fs14">颜色</span>
                  <cx-color-picker
                    class="flex1"
                    :isThemeColor.sync="hoverIconColorIsThemeColor"
                    :colorArr.sync="hoverIconColor"
                  />
                </div>
                <slider-and-input
                  class="mb16"
                  :value.sync="hoverIconWidth"
                  title="大小"
                  :sliderMax="filterWidth"
                  suffix="px"
                />
                <slider-and-input :value.sync="hoverIconMargin" title="间距" :sliderMax="filterWidth" suffix="px" />
              </div>
            </el-collapse-item> -->
            <el-collapse-item title="边框" name="4">
              <div>
                <div class="content-item verticallyCenter mb12">
                  <el-checkbox v-model="hoverShowBorder">显示边框</el-checkbox>
                </div>
                <cx-border
                  v-if="hoverShowBorder"
                  :borderWidth.sync="hoverBorderWidth"
                  :borderStyle.sync="hoverBorderStyle"
                  :borderColor.sync="hoverBorderColor"
                  :borderIsThemeColor.sync="hoverBorderIsThemeColor"
                />
              </div>
              <div class="content-item mt12">
                <border-radius
                  :borderTypeFlag.sync="hoverBorderTypeFlag"
                  :borderRadius.sync="hoverBorderRadius"
                  :borderTopLeftRadius.sync="hoverBorderTopLeftRadius"
                  :borderTopRightRadius.sync="hoverBorderTopRightRadius"
                  :borderBottomRightRadius.sync="hoverBorderBottomRightRadius"
                  :borderBottomLeftRadius.sync="hoverBorderBottomLeftRadius"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item title="更多" name="5">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span
                v-show="hoverBorderShadowChecked"
                  class="icon-portal-plus theme-color right-icon"
                  @click="addBoxshadow('hoverB')"
                ></span>
              </div>
              <box-shadow
                v-show="hoverBorderShadowChecked"
                :boxShadowH.sync="hoverBoxShadowH"
                :boxShadowV.sync="hoverBoxShadowV"
                :boxShadowBlur.sync="hoverBoxShadowBlur"
                :boxShadowSpread.sync="hoverBoxShadowSpread"
                :boxShadowColor.sync="hoverBoxShadowColor"
              ></box-shadow>
            </el-collapse-item>
          </template>
          <template v-if="subActiveType === '3'">
            <el-collapse-item title="文字" name="1">
              <text-setting-complex-update
                :fontFamily.sync="activeFontFamily"
                :fontSize.sync="activeFontSize"
                :fontWeight.sync="activeFontWeight"
                :fontStyle.sync="activeFontStyle"
                :textDecoration.sync="activeTextDecoration"
                :lineHeight.sync="activeLineHeight"
                :lineHeightType.sync="activeLineHeightType"
                :letterSpacing.sync="activeLetterSpacing"
                :showTextAlignSetting="false"
                :isThemeColor.sync="activeColorIsThemeColor"
                :colorArr.sync="activeColor"
                :options="options"
              />
            </el-collapse-item>
            <el-collapse-item title="背景" name="2">
              <cx-background infoTips="支持上传图片" :background.sync="activeBackground" imgType="10" />
            </el-collapse-item>
            <el-collapse-item title="图标" name="3">
              <el-checkbox v-model="showActiveIcon">显示图标</el-checkbox>
              <div class="content-item mt12" v-if="showActiveIcon">
                <img-icon-upload
                  class="mb16"
                  :imgSrc.sync="activeIconSrc"
                  :iconType.sync="activeIconType"
                  :iconColor.sync="activeIconColor"
                  :resInfo.sync="activeResInfo"
                />
                <div v-show="activeIconSrc.length" class="content-item mb16 verticallyCenter">
                  <span class="mr16 fs14">位置</span>
                  <el-radio-group v-model="activeIconPosition">
                    <el-radio label="top">上</el-radio>
                    <el-radio label="bottom">下</el-radio>
                    <el-radio label="left">左</el-radio>
                    <el-radio label="right">右</el-radio>
                  </el-radio-group>
                </div>
                <div class="verticallyCenter mb16" v-if="activeIconType === 'icon'">
                  <span class="mr16 fs14">颜色</span>
                  <cx-color-picker
                    class="flex1"
                    :isThemeColor.sync="activeIconColorIsThemeColor"
                    :colorArr.sync="activeIconColor"
                  />
                </div>
                <slider-and-input
                  class="mb16"
                  :value.sync="activeIconWidth"
                  title="大小"
                  :sliderMax="filterWidth"
                  suffix="px"
                />
                <slider-and-input :value.sync="activeIconMargin" title="间距" :sliderMax="filterWidth" suffix="px" />
              </div>
            </el-collapse-item>
            <el-collapse-item title="边框" name="3">
              <div>
                <div class="content-item verticallyCenter mb12">
                  <el-checkbox v-model="activeShowBorder">显示边框</el-checkbox>
                </div>
                <cx-border
                  v-if="activeShowBorder"
                  :borderWidth.sync="activeBorderWidth"
                  :borderStyle.sync="activeBorderStyle"
                  :borderColor.sync="activeBorderColor"
                  :borderIsThemeColor.sync="activeBorderIsThemeColor"
                />
              </div>
              <div class="content-item mt12">
                <border-radius
                  :borderTypeFlag.sync="activeBorderTypeFlag"
                  :borderRadius.sync="activeBorderRadius"
                  :borderTopLeftRadius.sync="activeBorderTopLeftRadius"
                  :borderTopRightRadius.sync="activeBorderTopRightRadius"
                  :borderBottomRightRadius.sync="activeBorderBottomRightRadius"
                  :borderBottomLeftRadius.sync="activeBorderBottomLeftRadius"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item title="更多" name="4">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span
                  v-show="hoverBorderShadowChecked"
                  class="icon-portal-plus theme-color right-icon"
                  @click="addBoxshadow('activeB')"
                ></span>
              </div>
              <box-shadow
                :boxShadowH.sync="activeBoxShadowH"
                :boxShadowV.sync="activeBoxShadowV"
                :boxShadowBlur.sync="activeBoxShadowBlur"
                :boxShadowSpread.sync="activeBoxShadowSpread"
                :boxShadowColor.sync="activeBoxShadowColor"
              ></box-shadow>
            </el-collapse-item>
          </template>
        </template>
        <template v-if="curFilter === 6">
          <div class="navBackBox" @click="changeFilter(2, true)">
            <i class="navBackIcon icon-portal-arrows-left"></i>
            <span class="navBackTitle">确定按钮</span>
          </div>
          <button-set :options="options" buttonType="sureButton"></button-set>
        </template>
        <template v-if="curFilter === 7">
          <div class="navBackBox" @click="changeFilter(2, true)">
            <i class="navBackIcon icon-portal-arrows-left"></i>
            <span class="navBackTitle">重置按钮</span>
          </div>
          <button-set :options="options" buttonType="resetButton"></button-set>
        </template>
        <!-- 展开收起按钮 -->
        <template v-if="curFilter === 8 || model === 'tree'">
          <div class="navBackBox" @click="changeFilter(0, false)">
            <i class="navBackIcon icon-portal-arrows-left"></i>
            <span class="navBackTitle">展开收起按钮</span>
          </div>
          <div class="content-item verticallyCenter paddingl15 lineHeight32 bb1b9 pb8">
            <el-checkbox v-model="buttonShow">显示展开收起按钮</el-checkbox>
          </div>
          <template v-if="buttonShow">
            <toggle-button-set :options="options" buttonType="toggleButton"></toggle-button-set>
          </template>
        </template>
        <el-collapse-item
          v-show="$store.state.states.showPluginSetting"
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')"
          title="插件"
          name="8"
        >
          <div
            class="setting-item">
            <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>开启已选状态后：</span>会在一级分类的位置回显所选的选项名称，如下图所示：
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
import rowColLayoutSize from "publicSetting/rowColLayoutSize"
import widthAndHeightSize from "publicSetting/widthAndHeightSize"
import { isInAutoLayout } from "utils"
import { withMethodsHistoryCombine } from "utils/revork"
import { simpleDeepClone } from "../../../utils"
import CustomSubMenuSetting from "../render/customSubMenus/setting"
import buttonSet from "./button-set.vue"
import toggleButtonSet from "./toggle-button-set.vue"
export default withMethodsHistoryCombine({
  name: "multiFilter-options-setting",
  components: { elementPluginSetting, rowColLayoutSize, widthAndHeightSize, CustomSubMenuSetting, buttonSet, toggleButtonSet },
  props: { options: Object },
  data() {
    return {
      this1: this,
      explainDialog: false,
      explainImgSrc: require("../../../assets/images/tipsVideoImg/filter-tips.png"),
      activeNames: ["1", "2", "3", "4", "5"],
      collapseActiveNames: ["1", "2"],
      allCollapseNames: ["1", "2", "3", "4", "5"],
      titleBorderShadowChecked: true,
      defaultBorderShadowChecked: true,
      hoverBorderShadowChecked: true,
      activeBorderShadowChecked: true,
      sliderMax: 100,
      autoWidth: "0", //是否固定宽度
      activeStatus: "status0",
      isInAutoLayout: false,
      curFilter: 0,
      arrangeTypeOptions: [
        {
          value: "horizontal",
          iconClass: "icon-portal-direction-right"
        },
        {
          value: "vertical",
          iconClass: "icon-portal-direction-down"
        }
      ],
      alignmentTypeOptions: [
        {
          value: "left",
          label: "左对齐",
          iconClass: "icon-portal-Align-left"
        },
        {
          value: "center",
          label: "居中对齐",
          iconClass: "icon-portal-Center-lr"
        },
        {
          value: "right",
          label: "右对齐",
          iconClass: "icon-portal-Align-right"
        }
      ],
      activeTypeOptions: [
        { value: "1", title: "默认" },
        { value: "3", title: "选中" }
      ],
      subActiveTypeOptions: [
        { value: "1", title: "默认" },
        { value: "2", title: "悬浮" },
        { value: "3", title: "选中" }
      ],
      activeType: "1",
      subActiveType: "1",
      defaultImg: require("../../../assets/images/default_image_home.png"),
      currentSetStyle: "",
      currentSetMenu: "",
      filterTypeOptions: [
        { value: "1", title: "单选" },
        { value: "2", title: "多选" },
      ],
      overflowTypes1: ['字数', '无'],
      overflowTypes2: ['行数', '字数', '无']
    }
  },
  computed: {
    subMenuConfig: {
      get() {
        return JSON.parse(JSON.stringify(this.options.subMenuConfig || []))
      },
      set(val) {
        return this.$changeOptionsEV(val, 'subMenuConfig', false)
      }
    },
    ids() {
      return this.$store.state.states.activeID
    },
    color: {
      get() {
        return this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.bgColorIsThemeColor,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "background", false)
      }
    },
    bgColorIsThemeColor: {
      get() {
        return this.options.bgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColorIsThemeColor", false)
      }
    },
    imgSrc: {
      get() {
        return this.options.imgSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "imgSrc", false)
      }
    },
    opacity: {
      get() {
        return this.options.opacity * 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal / 100, "opacity", false)
      }
    },
    borderTypeFlag: {
      get() {
        return this.options.borderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderRadius", "borderRadius", this.borderTopLeftRadius)
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.$changeOptionsEV(
            [newVal, newVal, newVal, newVal, newVal],
            [
              "borderTopLeftRadius",
              "borderTopRightRadius",
              "borderBottomLeftRadius",
              "borderBottomRightRadius",
              "borderRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "borderRadius", false)
        }
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.options.borderTopLeftRadius
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.$changeOptionsEV(
            [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
            ["borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius", "borderTopLeftRadius"],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
        }
      }
    },
    borderTopRightRadius: {
      get() {
        return this.options.borderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.options.borderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.options.borderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderWidth: {
      get() {
        return this.options.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.options.borderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.boxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    // 边距
    paddingTypeFlag: {
      get() {
        let defaultType = 2
        if (((this.paddingTop === this.paddingRight) === this.paddingLeft) === this.paddingBottom) {
          defaultType = 1
        }
        return this.options.paddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },

    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.options.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontWeight", false)
      }
    },
    fontStyle: {
      get() {
        return this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontStyle", false)
      }
    },
    textDecoration: {
      get() {
        return this.options.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textDecoration", false)
      }
    },
    lineHeight: {
      get() {
        return this.options.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeight", false)
      }
    },
    lineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "lineHeightType", "lineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeightType", false)
        /**/
      }
    },
    letterSpacing: {
      get() {
        return this.options.letterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacing", false)
      }
    },

    writingMode: {
      get() {
        return this.options.writingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "writingMode", false)
      }
    },
    textAlign: {
      get() {
        return this.options.textAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textAlign", false)
      }
    },
    letterSpacingType: {
      get() {
        return this.options.letterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacingType", false)
      }
    },
    activeArrangement() {
      return this.options.textAlign
    },
    activeArrangementOrder: {
      get() {
        return {
          label: "竖排文字",
          _class: "icon-portal-text-down1",
          isActive: this.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.writingMode = val
      }
    },

    textIsThemeColor: {
      get() {
        return this.options.textIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIsThemeColor", false)
      }
    },
    lineMargin: {
      get() {
        return this.options.lineMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineMargin", false)
      }
    },
    columnMargin: {
      get() {
        return this.options.columnMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "columnMargin", false)
      }
    },
    moreFilter: {
      get() {
        return this.options.moreFilter
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreFilter", false)
      }
    },
    model() {
      return this.options.model
    },
    groupMargin: {
      get() {
        return this.options.groupMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "groupMargin", false)
      }
    },
    contentHasLimit: {
      get() {
        return this.options.contentHasLimit
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "contentHasLimit", false)
      }
    },
    textLimitLines: {
      get() {
        return this.options.textLimitLines
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textLimitLines", false)
      }
    },

    //子分类 默认
    defaultBorderTypeFlag: {
      get() {
        return this.options.defaultBorderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBorderTypeFlag", false)
      }
    },
    defaultBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "defaultBorderRadius",
          "defaultBorderRadius",
          this.defaultBorderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.defaultBorderTypeFlag === 2) {
          this.defaultBorderTopLeftRadius = newVal
          this.defaultBorderTopRightRadius = newVal
          this.defaultBorderBottomLeftRadius = newVal
          this.defaultBorderBottomRightRadius = newVal
        }
        this.$changeOptionsEV(newVal, "defaultBorderRadius", false)
      }
    },
    defaultBorderTopLeftRadius: {
      get() {
        return this.options.defaultBorderTopLeftRadius
      },
      set(newVal) {
        if (this.defaultBorderTypeFlag === 2) {
          this.$changeOptionsEV(
            [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
            [
              "defaultBorderTopRightRadius",
              "defaultBorderBottomRightRadius",
              "defaultBorderBottomLeftRadius",
              "defaultBorderTopLeftRadius"
            ],
            false
          )
          this.$changeOptionsEV(parseInt(newVal), "defaultBorderBottomRightRadius", false)
          this.$changeOptionsEV(parseInt(newVal), "defaultBorderBottomLeftRadius", false)
        } else {
          this.$changeOptionsEV(newVal, "defaultBorderTopLeftRadius", false)
        }
      }
    },
    defaultBorderTopRightRadius: {
      get() {
        return this.options.defaultBorderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBorderTopRightRadius", false)
      }
    },
    defaultBorderBottomRightRadius: {
      get() {
        return this.options.defaultBorderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBorderBottomRightRadius", false)
      }
    },
    defaultBorderBottomLeftRadius: {
      get() {
        return this.options.defaultBorderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBorderBottomLeftRadius", false)
      }
    },
    defaultShowBorder: {
      get() {
        let showBorder = false
        if (this.options.defaultShowBorder === undefined) {
          if (Array.isArray(this.options.defaultBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.defaultBorderWidth.length; i++) {
              if (this.options.defaultBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.defaultBorderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
        } else {
          showBorder = this.options.defaultShowBorder
        }
        return showBorder
      },
      set(newVal) {
        if (newVal && !this.defaultBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["defaultBorderWidth", "defaultShowBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "defaultShowBorder", false)
        }
      }
    },
    defaultBorderWidth: {
      get() {
        return this.options.defaultBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBorderWidth", false)
      }
    },
    defaultBorderStyle: {
      get() {
        return this.options.defaultBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBorderStyle", false)
      }
    },
    defaultBorderColor: {
      get() {
        return this.options.defaultBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBorderColor", false)
      }
    },
    defaultBorderIsThemeColor: {
      get() {
        return this.options.defaultBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBorderIsThemeColor", false)
      }
    },
    defaultPaddingTypeFlag: {
      get() {
        let defaultType = 2
        if (
          ((this.defaultPaddingTop === this.defaultPaddingRight) === this.defaultPaddingLeft) ===
          this.defaultPaddingBottom
        ) {
          defaultType = 1
        }
        return this.options.defaultPaddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultPaddingTypeFlag", false)
      }
    },
    defaultPadding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "defaultPadding", "defaultPadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultPadding", false)
      }
    },
    defaultPaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "defaultPaddingTop", "defaultPaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultPaddingTop", false)
      }
    },
    defaultPaddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "defaultPaddingRight", "defaultPaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultPaddingRight", false)
      }
    },
    defaultPaddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "defaultPaddingLeft", "defaultPaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultPaddingLeft", false)
      }
    },
    defaultPaddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "defaultPaddingBottom", "defaultPaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultPaddingBottom", false)
      }
    },
    defaultBackground: {
      get() {
        let defaultBackground = this.options.defaultBackground
        if (defaultBackground && Array.isArray(defaultBackground) && defaultBackground.length > 0) {
          return this.options.defaultBackground
        }
        let newDefaultBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.defaultBgColorIsThemeColor,
            color: this.options.defaultBgColor
          }
        ]
        this.$changeOptionsEV(newDefaultBackground, "defaultBackground", false, false, false, true)
        return newDefaultBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBackground", false)
      }
    },
    defaultBgColorIsThemeColor: {
      get() {
        return this.options.defaultBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBgColorIsThemeColor", false)
      }
    },
    defaultBgColor: {
      get() {
        return this.options.defaultBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBgColor", false)
      }
    },
    defaultBoxShadowColor: {
      get() {
        return this.options.defaultBoxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBoxShadowColor", false)
      }
    },
    defaultBoxShadowH: {
      get() {
        return this.options.defaultBoxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBoxShadowH", false)
      }
    },
    defaultBoxShadowV: {
      get() {
        return this.options.defaultBoxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBoxShadowV", false)
      }
    },
    defaultBoxShadowBlur: {
      get() {
        return this.options.defaultBoxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBoxShadowBlur", false)
      }
    },
    defaultBoxShadowSpread: {
      get() {
        return this.options.defaultBoxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBoxShadowSpread", false)
      }
    },
    showDefaultIcon: {
      get() {
        return this.options.showDefaultIcon
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showDefaultIcon", false)
      }
    },
    defaultIconSrc: {
      get() {
        return this.options.defaultIconSrc || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultIconSrc", false)
      }
    },
    defaultIconType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "defaultIconType", "defaultIconType", "icon")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultIconType", false)
      }
    },
    defaultIconWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "defaultIconWidth", "defaultIconWidth", 14)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultIconWidth", false)
      }
    },
    defaultIconMargin: {
      get() {
        return this.options.defaultIconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultIconMargin", false)
      }
    },
    defaultIconColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "defaultIconColor", "defaultIconColor", "#999999")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultIconColor", false)
      }
    },
    defaultIconColorIsThemeColor: {
      get() {
        return this.options.defaultIconColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultIconColorIsThemeColor", false)
      }
    },
    defaultIconPosition: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "defaultIconPosition", "defaultIconPosition", "left")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultIconPosition", false)
      }
    },
    defaultResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "defaultResInfo", "defaultResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultResInfo", false)
      }
    },
    subMenuWidthAuto: {
      get() {
        return this.options.hasOwnProperty("subMenuWidthAuto") ? this.options.subMenuWidthAuto : true
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subMenuWidthAuto", false)
      }
    },
    subMenuWidth: {
      get() {
        return this.options.subMenuWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subMenuWidth", false)
      }
    },
    subMenuWidthFull: {
      get() {
        return this.options.subMenuWidthFull
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subMenuWidthFull", false)
      }
    },
    subMenuHeightAuto: {
      get() {
        return this.options.hasOwnProperty("subMenuHeightAuto") ? this.options.subMenuHeightAuto : true
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subMenuHeightAuto", false)
      }
    },
    subMenuHeight: {
      get() {
        return this.options.subMenuHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subMenuHeight", false)
      }
    },
    subMenuHeightFull: {
      get() {
        return this.options.subMenuHeightFull
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subMenuHeightFull", false)
      }
    },
    titleFontFamily: {
      get() {
        return this.options.titleFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleFontFamily", false)
      }
    },
    titleFontSize: {
      get() {
        return this.options.titleFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleFontSize", false)
      }
    },
    titleFontWeight: {
      get() {
        return this.options.titleFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleFontWeight", false)
      }
    },
    titleFontStyle: {
      get() {
        return this.options.titleFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleFontStyle", false)
      }
    },
    titleTextDecoration: {
      get() {
        return this.options.titleTextDecoration || "none"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleTextDecoration", false)
      }
    },
    titleLineHeight: {
      get() {
        return this.options.titleLineHeight || 50
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleLineHeight", false)
      }
    },
    titleLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titleLineHeightType", "titleLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleLineHeightType", false)
      }
    },
    titleLetterSpacing: {
      get() {
        return this.options.titleLetterSpacing || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleLetterSpacing", false)
      }
    },
    titleTextAlign: {
      get() {
        return this.options.titleTextAlign || "left"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleTextAlign", false)
      }
    },
    titleArrangement() {
      return this.options.titleTextAlign
    },
    titleWritingMode: {
      get() {
        return this.options.titleWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleWritingMode", false)
      }
    },
    titleArrangementOrder: {
      get() {
        return {
          label: "竖排文字",
          _class: "icon-portal-text-down1",
          isActive: this.titleWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.titleWritingMode = val
      }
    },
    titleTextIsThemeColor: {
      get() {
        return this.options.titleTextIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleTextIsThemeColor", false)
      }
    },
    titleColor: {
      get() {
        return this.options.titleColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleColor", false)
      }
    },
    titleContentHasLimit: {
      get() {
        return this.options.titleContentHasLimit
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleContentHasLimit", false)
      }
    },
    titleTextLimitLines: {
      get() {
        return this.options.titleTextLimitLines
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleTextLimitLines", false)
      }
    },
    titleBackground: {
      get() {
        let titleBackground = this.options.titleBackground
        if (titleBackground && Array.isArray(titleBackground) && titleBackground.length > 0) {
          return this.options.titleBackground
        }
        let newTitleBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.titleBgColorIsThemeColor,
            color: this.options.titleBgColor
          }
        ]
        this.$changeOptionsEV(newTitleBackground, "titleBackground", false, false, false, true)
        return newTitleBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBackground", false)
      }
    },
    titleBgColorIsThemeColor: {
      get() {
        return this.options.titleBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBgColorIsThemeColor", false)
      }
    },
    titleBgColor: {
      get() {
        return this.options.titleBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBgColor", false)
      }
    },

    titleBoxShadowColor: {
      get() {
        return this.options.titleBoxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBoxShadowColor", false)
      }
    },
    titleBoxShadowH: {
      get() {
        return this.options.titleBoxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBoxShadowH", false)
      }
    },
    titleBoxShadowV: {
      get() {
        return this.options.titleBoxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBoxShadowV", false)
      }
    },
    titleBoxShadowBlur: {
      get() {
        return this.options.titleBoxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBoxShadowBlur", false)
      }
    },
    titleBoxShadowSpread: {
      get() {
        return this.options.titleBoxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBoxShadowSpread", false)
      }
    },

    // 标题边距
    titlePaddingTypeFlag: {
      get() {
        let defaultType = 2
        if (((this.titlePaddingTop === this.titlePaddingRight) === this.titlePaddingLeft) === this.titlePaddingBottom) {
          defaultType = 1
        }
        return this.options.titlePaddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingTypeFlag", false)
      }
    },
    titlePadding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titlePadding", "titlePadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePadding", false)
      }
    },
    titlePaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titlePaddingTop", "titlePaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingTop", false)
      }
    },
    titlePaddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titlePaddingRight", "titlePaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingRight", false)
      }
    },
    titlePaddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titlePaddingLeft", "titlePaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingLeft", false)
      }
    },
    titlePaddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titlePaddingBottom", "titlePaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingBottom", false)
      }
    },
    titleBorderShow: {
      get() {
        let titleBorderShow = false
        if (this.options.titleBorderShow === undefined) {
          if (Array.isArray(this.options.titleBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.titleBorderWidth.length; i++) {
              if (this.options.titleBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              titleBorderShow = false
            } else {
              titleBorderShow = true
            }
          } else {
            if (this.options.titleBorderWidth) {
              titleBorderShow = true
            } else {
              titleBorderShow = false
            }
          }
        } else {
          titleBorderShow = this.options.titleBorderShow
        }
        return titleBorderShow
      },
      set(newVal) {
        if (newVal && !this.titleBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["titleBorderWidth", "titleBorderShow"], false)
        } else {
          this.$changeOptionsEV(newVal, "titleBorderShow", false)
        }
      }
    },
    titleBorderTypeFlag: {
      get() {
        return this.options.titleBorderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBorderTypeFlag", false)
      }
    },
    titleBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "titleBorderRadius",
          "titleBorderRadius",
          this.titleBorderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.titleBorderTypeFlag === 2) {
          this.titleBorderTopLeftRadius = newVal
          this.titleBorderTopRightRadius = newVal
          this.titleBorderBottomLeftRadius = newVal
          this.titleBorderBottomRightRadius = newVal
        }
        this.$changeOptionsEV(newVal, "titleBorderRadius", false)
      }
    },
    titleBorderTopLeftRadius: {
      get() {
        return this.options.titleBorderTopLeftRadius
      },
      set(newVal) {
        if (this.titleBorderTypeFlag === 2) {
          this.$changeOptionsEV(
            [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
            [
              "titleBorderTopRightRadius",
              "titleBorderBottomRightRadius",
              "titleBorderBottomLeftRadius",
              "titleBorderTopLeftRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "titleBorderTopLeftRadius", false)
        }
      }
    },
    titleBorderTopRightRadius: {
      get() {
        return this.options.titleBorderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBorderTopRightRadius", false)
      }
    },
    titleBorderBottomRightRadius: {
      get() {
        return this.options.titleBorderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBorderBottomRightRadius", false)
      }
    },
    titleBorderBottomLeftRadius: {
      get() {
        return this.options.titleBorderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBorderBottomLeftRadius", false)
      }
    },
    titleBorderWidth: {
      get() {
        return this.options.titleBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBorderWidth", false)
      }
    },
    titleBorderStyle: {
      get() {
        return this.options.titleBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBorderStyle", false)
      }
    },
    titleBorderColor: {
      get() {
        return this.options.titleBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBorderColor", false)
      }
    },
    titleBorderIsThemeColor: {
      get() {
        return this.options.titleBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBorderIsThemeColor", false)
      }
    },

    hoverFontFamily: {
      get() {
        return this.options.hoverFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontFamily", false)
      }
    },
    hoverFontSize: {
      get() {
        return this.options.hoverFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontSize", false)
      }
    },
    hoverFontWeight: {
      get() {
        return this.options.hoverFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontWeight", false)
      }
    },
    hoverFontStyle: {
      get() {
        return this.options.hoverFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontStyle", false)
      }
    },
    hoverTextDecoration: {
      get() {
        return this.options.hoverTextDecoration || "none"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextDecoration", false)
      }
    },
    hoverLineHeight: {
      get() {
        return this.options.hoverLineHeight || 50
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLineHeight", false)
      }
    },
    hoverLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "hoverLineHeightType", "hoverLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLineHeightType", false)
        /**/
      }
    },
    hoverLetterSpacing: {
      get() {
        return this.options.hoverLetterSpacing || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLetterSpacing", false)
      }
    },
    hoverColorIsThemeColor: {
      get() {
        return this.options.hoverColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverColorIsThemeColor", false)
      }
    },
    hoverColor: {
      get() {
        return this.options.hoverColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverColor", false)
      }
    },

    hoverBorderTypeFlag: {
      get() {
        return this.options.hoverBorderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderTypeFlag", false)
      }
    },
    hoverBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "hoverBorderRadius",
          "hoverBorderRadius",
          this.hoverBorderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.hoverBorderTypeFlag === 2) {
          this.hoverBorderTopLeftRadius = newVal
          this.hoverBorderTopRightRadius = newVal
          this.hoverBorderBottomRightRadius = newVal
          this.hoverBorderBottomLeftRadius = newVal
        }
        this.$changeOptionsEV(newVal, "hoverBorderRadius", false)
      }
    },
    hoverBorderTopLeftRadius: {
      get() {
        return this.options.hoverBorderTopLeftRadius
      },
      set(newVal) {
        if (this.hoverBorderTypeFlag === 2) {
          this.$changeOptionsEV(
            [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
            [
              "hoverBorderTopRightRadius",
              "hoverBorderBottomRightRadius",
              "hoverBorderBottomLeftRadius",
              "hoverBorderTopLeftRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "hoverBorderTopLeftRadius", false)
        }
      }
    },
    hoverBorderTopRightRadius: {
      get() {
        return this.options.hoverBorderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderTopRightRadius", false)
      }
    },
    hoverBorderBottomRightRadius: {
      get() {
        return this.options.hoverBorderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderBottomRightRadius", false)
      }
    },
    hoverBorderBottomLeftRadius: {
      get() {
        return this.options.hoverBorderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderBottomLeftRadius", false)
      }
    },
    hoverBgColorIsThemeColor: {
      get() {
        return this.options.hoverBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBgColorIsThemeColor", false)
      }
    },
    hoverBgColor: {
      get() {
        return this.options.hoverBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBgColor", false)
      }
    },
    hoverShowBorder: {
      get() {
        let showBorder = false
        if (this.options.hoverShowBorder === undefined) {
          if (Array.isArray(this.options.hoverBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.hoverBorderWidth.length; i++) {
              if (this.options.hoverBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.hoverBorderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
        } else {
          showBorder = this.options.hoverShowBorder
        }
        return showBorder
      },
      set(newVal) {
        if (newVal && !this.hoverBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["hoverBorderWidth", "hoverShowBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "hoverShowBorder", false)
        }
      }
    },
    hoverBorderWidth: {
      get() {
        return this.options.hoverBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderWidth", false)
      }
    },
    hoverBorderStyle: {
      get() {
        return this.options.hoverBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderStyle", false)
      }
    },
    hoverBorderColor: {
      get() {
        return this.options.hoverBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderColor", false)
      }
    },
    showHoverBorder: {
      get() {
        return this.options.showHoverBorder
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showHoverBorder", false)
      }
    },
    hoverBorderIsThemeColor: {
      get() {
        return this.options.hoverBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderIsThemeColor", false)
      }
    },
    hoverBackground: {
      get() {
        let hoverBackground = this.options.hoverBackground
        if (hoverBackground && Array.isArray(hoverBackground) && hoverBackground.length > 0) {
          return this.options.hoverBackground
        }
        let newHoverBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.hoverBgColorIsThemeColor,
            color: this.options.hoverBgColor
          }
        ]
        this.$changeOptionsEV(newHoverBackground, "hoverBackground", false, false, false, true)
        return newHoverBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBackground", false)
      }
    },
    hoverBoxShadowColor: {
      get() {
        return this.options.hoverBoxShadowColor || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBoxShadowColor", false)
      }
    },
    hoverBoxShadowH: {
      get() {
        return this.options.hoverBoxShadowH || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBoxShadowH", false)
      }
    },
    hoverBoxShadowV: {
      get() {
        return this.options.hoverBoxShadowV || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBoxShadowV", false)
      }
    },
    hoverBoxShadowBlur: {
      get() {
        return this.options.hoverBoxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBoxShadowBlur", false)
      }
    },
    hoverBoxShadowSpread: {
      get() {
        return this.options.hoverBoxShadowSpread || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBoxShadowSpread", false)
      }
    },
    hoverActiveIcon: {
      get() {
        return this.options.hoverActiveIcon
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverActiveIcon", false)
      }
    },
    hoverIconSrc: {
      get() {
        return this.options.hoverIconSrc || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverIconSrc", false)
      }
    },
    hoverIconType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "hoverIconType", "hoverIconType", "icon")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverIconType", false)
      }
    },
    hoverIconWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "hoverIconWidth", "hoverIconWidth", 14)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverIconWidth", false)
      }
    },
    hoverIconMargin: {
      get() {
        return this.options.hoverIconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverIconMargin", false)
      }
    },
    hoverIconColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "hoverIconColor", "hoverIconColor", "#999999")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverIconColor", false)
      }
    },
    hoverIconColorIsThemeColor: {
      get() {
        return this.options.hoverIconColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverIconColorIsThemeColor", false)
      }
    },
    hoverIconPosition: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "hoverIconPosition", "hoverIconPosition", "left")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverIconPosition", false)
      }
    },
    hoverResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "hoverResInfo", "hoverResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverResInfo", false)
      }
    },

    activeFontFamily: {
      get() {
        return this.options.activeFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontFamily", false)
      }
    },
    activeFontSize: {
      get() {
        return this.options.activeFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontSize", false)
      }
    },
    activeFontWeight: {
      get() {
        return this.options.activeFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontWeight", false)
      }
    },
    activeFontStyle: {
      get() {
        return this.options.activeFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontStyle", false)
      }
    },
    activeTextDecoration: {
      get() {
        return this.options.activeTextDecoration || "none"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTextDecoration", false)
      }
    },
    activeLineHeight: {
      get() {
        return this.options.activeLineHeight || 50
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLineHeight", false)
      }
    },
    activeLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeLineHeightType", "activeLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLineHeightType", false)
        /**/
      }
    },
    activeLetterSpacing: {
      get() {
        return this.options.activeLetterSpacing || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLetterSpacing", false)
      }
    },
    activeColorIsThemeColor: {
      get() {
        return this.options.activeColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeColorIsThemeColor", false)
      }
    },
    activeColor: {
      get() {
        return this.options.activeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeColor", false)
      }
    },
    activeBorderTypeFlag: {
      get() {
        return this.options.activeBorderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderTypeFlag", false)
      }
    },
    activeBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "activeBorderRadius",
          "activeBorderRadius",
          this.activeBorderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.activeBorderTypeFlag === 2) {
          this.activeBorderTopLeftRadius = newVal
          this.activeBorderTopRightRadius = newVal
          this.activeBorderBottomRightRadius = newVal
          this.activeBorderBottomLeftRadius = newVal
        }
        this.$changeOptionsEV(newVal, "activeBorderRadius", false)
      }
    },
    activeBorderTopLeftRadius: {
      get() {
        return this.options.activeBorderTopLeftRadius
      },
      set(newVal) {
        if (this.activeBorderTypeFlag === 2) {
          this.$changeOptionsEV(
            [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
            [
              "activeBorderTopRightRadius",
              "activeBorderBottomRightRadius",
              "activeBorderBottomLeftRadius",
              "activeBorderTopLeftRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "activeBorderTopLeftRadius", false)
        }
      }
    },
    activeBorderTopRightRadius: {
      get() {
        return this.options.activeBorderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderTopRightRadius", false)
      }
    },
    activeBorderBottomRightRadius: {
      get() {
        return this.options.activeBorderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderBottomRightRadius", false)
      }
    },
    activeBorderBottomLeftRadius: {
      get() {
        return this.options.activeBorderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderBottomLeftRadius", false)
      }
    },
    activeBgColorIsThemeColor: {
      get() {
        return this.options.activeBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBgColorIsThemeColor", false)
      }
    },
    activeBgColor: {
      get() {
        return this.options.activeBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBgColor", false)
      }
    },
    activeShowBorder: {
      get() {
        let showBorder = false
        if (this.options.activeShowBorder === undefined) {
          if (Array.isArray(this.options.activeBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.activeBorderWidth.length; i++) {
              if (this.options.activeBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.activeBorderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
        } else {
          showBorder = this.options.activeShowBorder
        }
        return showBorder
      },
      set(newVal) {
        if (newVal && !this.activeBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["activeBorderWidth", "activeShowBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "activeShowBorder", false)
        }
      }
    },
    activeBorderWidth: {
      get() {
        return this.options.activeBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderWidth", false)
      }
    },
    activeBorderStyle: {
      get() {
        return this.options.activeBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderStyle", false)
      }
    },
    activeBorderColor: {
      get() {
        return this.options.activeBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderColor", false)
      }
    },
    activeBorderIsThemeColor: {
      get() {
        return this.options.activeBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderIsThemeColor", false)
      }
    },
    activeBackground: {
      get() {
        let activeBackground = this.options.activeBackground
        if (activeBackground && Array.isArray(activeBackground) && activeBackground.length > 0) {
          return this.options.activeBackground
        }
        let newActiveBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.activeBgColorIsThemeColor,
            color: this.options.activeBgColor
          }
        ]
        this.$changeOptionsEV(newActiveBackground, "activeBackground", false, false, false, true)
        return newActiveBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBackground", false)
      }
    },
    activeBoxShadowColor: {
      get() {
        return this.options.activeBoxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBoxShadowColor", false)
      }
    },
    activeBoxShadowH: {
      get() {
        return this.options.activeBoxShadowH || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBoxShadowH", false)
      }
    },
    activeBoxShadowV: {
      get() {
        return this.options.activeBoxShadowV || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBoxShadowV", false)
      }
    },
    activeBoxShadowBlur: {
      get() {
        return this.options.activeBoxShadowBlur || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBoxShadowBlur", false)
      }
    },
    activeBoxShadowSpread: {
      get() {
        return this.options.activeBoxShadowSpread || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBoxShadowSpread", false)
      }
    },
    showActiveIcon: {
      get() {
        return this.options.showActiveIcon
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showActiveIcon", false)
      }
    },
    activeIconSrc: {
      get() {
        return this.options.activeIconSrc || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconSrc", false)
      }
    },
    activeIconType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeIconType", "activeIconType", "icon")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconType", false)
      }
    },
    activeIconWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeIconWidth", "activeIconWidth", 14)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconWidth", false)
      }
    },
    activeIconMargin: {
      get() {
        return this.options.activeIconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconMargin", false)
      }
    },
    activeIconColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeIconColor", "activeIconColor", "#999999")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconColor", false)
      }
    },
    activeIconColorIsThemeColor: {
      get() {
        return this.options.activeIconColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconColorIsThemeColor", false)
      }
    },
    activeIconPosition: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeIconPosition", "activeIconPosition", "left")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconPosition", false)
      }
    },
    activeResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeResInfo", "activeResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeResInfo", false)
      }
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    filterWidthFull: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "filterWidthFull", "filterWidthFull", true)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filterWidthFull", false)
      }
    },
    filterWidthAuto: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "filterWidthAuto", "filterWidthAuto", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filterWidthAuto", false)
      }
    },
    filterHeightFull: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "filterHeightFull", "filterHeightFull", true)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filterHeightFull", false)
      }
    },
    filterHeightAuto: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "filterHeightAuto", "filterHeightAuto", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filterHeightAuto", false)
      }
    },
    filterWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "filterWidth", "filterWidth", 400)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filterWidth", false)
      }
    },
    filterHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "filterHeight", "filterHeight", 200)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filterHeight", false)
      }
    },
    filterAlignmentType: {
      get() {
        return this.options.filterAlignmentType || "left"
      },
      set(val) {
        this.$changeOptionsEV(val, "filterAlignmentType", false)
      }
    },
    arrangeType: {
      get() {
        return this.options.arrangeType || "horizontal"
      },
      set(val) {
        this.$changeOptionsEV(val, "arrangeType", false)
      }
    },
    filterMargin: {
      get() {
        return this.options.filterMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filterMargin", false)
      }
    },
    filterShowBorder: {
      get() {
        let showBorder = false
        if (this.options.filterShowBorder === undefined) {
          if (Array.isArray(this.options.borderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.borderWidth.length; i++) {
              if (this.options.borderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.borderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
        } else {
          showBorder = this.options.filterShowBorder
        }
        return showBorder
      },
      set(newVal) {
        if (newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "filterShowBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "filterShowBorder", false)
        }
      }
    },
    showBorder: {
      get() {
        return this.options.showBorder
      },
      set(newVal) {
        if (newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showBorder", false)
        }
      }
    },
    filterShowTabsScorll: {
      get() {
        return this.options.filterShowTabsScorll || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filterShowTabsScorll", false)
      }
    },
    titleWidthAuto: {
      get() {
        if (this.options.titleWidthAuto) {
          this.titleContentHasLimit = false
        } else {
          this.titleContentHasLimit = true
        }
        return this.options.hasOwnProperty("titleWidthAuto") ? this.options.titleWidthAuto : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleWidthAuto", false)
      }
    },
    titleHeightAuto: {
      get() {
        return this.options.titleHeightAuto
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleHeightAuto", false)
      }
    },
    titleWidth: {
      get() {
        if (this.options.titleWidth === undefined) {
          return this.options.titleWidth
        }
        return this.options.titleWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleWidth", false)
      }
    },
    titleHeight: {
      get() {
        return this.options.titleHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleHeight", false)
      }
    },
    titleWidthFull: {
      get() {
        return this.options.hasOwnProperty("titleWidthFull") ? this.options.titleWidthFull : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleWidthFull", false)
      }
    },
    titleContentHasLimitRadio: {
      get() {
        const defaultRadio = this.model === "filter" ? "字数" : "行数"
        return this.checkAndSetPrimaryVal(this.options, "titleContentHasLimitRadio", "titleContentHasLimitRadio", defaultRadio)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleContentHasLimitRadio", false)
      }
    },
    titleTextLimitCount: {
      get() {
        return this.options.titleTextLimitCount || 4
      },
      set(val) {
        this.$changeOptionsEV(val, "titleTextLimitCount", false)
      }
    },
    titleTextLimit: {
      get() {
        return this.options.hasOwnProperty("titleTextLimit") ? this.options.titleTextLimit : true
      },
      set(val) {
        this.$changeOptionsEV(val, "titleTextLimit", false)
      }
    },
    titleTitleIconShow: {
      get() {
        let hasIconSic = false
        if (this.options.titleTitleIconShow === undefined) {
          if (this.titleIconSrc.length > 0) {
            hasIconSic = true
          } else {
            hasIconSic = false
          }
        } else {
          hasIconSic = this.options.titleTitleIconShow
        }
        return hasIconSic
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleTitleIconShow", false)
      }
    },
    titleIconSrc: {
      get() {
        return this.options.titleIconSrc || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleIconSrc", false)
      }
    },
    titleIconType: {
      get() {
        return this.options.titleIconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleIconType", false)
      }
    },
    titleIconWidth: {
      get() {
        return this.options.titleIconWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleIconWidth", false)
      }
    },
    titleIconMargin: {
      get() {
        return this.options.titleIconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleIconMargin", false)
      }
    },
    titleIconColor: {
      get() {
        return this.options.titleIconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleIconColor", false)
      }
    },
    titleIconColorIsThemeColor: {
      get() {
        return this.options.titleIconColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleIconColorIsThemeColor", false)
      }
    },
    titleIconPosition: {
      get() {
        return this.options.titleIconPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleIconPosition", false)
      }
    },
    titleResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titleResInfo", "titleResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleResInfo", false)
      }
    },
    labelShow: {
      get() {
        return this.options.hasOwnProperty("labelShow") ? this.options.labelShow : false
      },
      set(val) {
        this.$changeOptionsEV(val, "labelShow", false)
      }
    },
    titleActiveFontFamily: {
      get() {
        return this.options.titleActiveFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveFontFamily", false)
      }
    },
    titleActiveFontSize: {
      get() {
        return this.options.titleActiveFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveFontSize", false)
      }
    },
    titleActiveFontWeight: {
      get() {
        return this.options.titleActiveFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveFontWeight", false)
      }
    },
    titleActiveFontStyle: {
      get() {
        return this.options.titleActiveFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveFontStyle", false)
      }
    },
    titleActiveTextDecoration: {
      get() {
        return this.options.titleActiveTextDecoration || "none"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveTextDecoration", false)
      }
    },
    titleActiveLineHeight: {
      get() {
        return this.options.titleActiveLineHeight || 50
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveLineHeight", false)
      }
    },
    titleActiveLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titleActiveLineHeightType", "titleActiveLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveLineHeightType", false)
      }
    },
    titleActiveLetterSpacing: {
      get() {
        return this.options.titleActiveLetterSpacing || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveLetterSpacing", false)
      }
    },
    titleActiveTextAlign: {
      get() {
        return this.options.titleActiveTextAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveTextAlign", false)
      }
    },
    titleActiveArrangement() {
      return this.options.titleActiveTextAlign
    },
    titleActiveWritingMode: {
      get() {
        return this.options.titleActiveWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveWritingMode", false)
      }
    },
    titleActiveArrangementOrder: {
      get() {
        return {
          label: "竖排文字",
          _class: "icon-portal-text-down1",
          isActive: this.titleActiveWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.titleActiveWritingMode = val
      }
    },
    titleActiveTextIsThemeColor: {
      get() {
        return this.options.titleActiveTextIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveTextIsThemeColor", false)
      }
    },
    titleActiveColor: {
      get() {
        return this.options.titleActiveColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveColor", false)
      }
    },
    titleActiveBackground: {
      get() {
        let titleBackground = this.options.titleActiveBackground
        if (titleBackground && Array.isArray(titleBackground) && titleBackground.length > 0) {
          return this.options.titleActiveBackground
        }
        let newTitleBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.titleActiveBgColorIsThemeColor,
            color: this.options.titleActiveBgColor
          }
        ]
        this.$changeOptionsEV(newTitleBackground, "titleActiveBackground", false, false, false, true)
        return newTitleBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveBackground", false)
      }
    },
    titleActiveBgColorIsThemeColor: {
      get() {
        return this.options.titleActiveBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveBgColorIsThemeColor", false)
      }
    },
    titleActiveBgColor: {
      get() {
        return this.options.titleActiveBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveBgColor", false)
      }
    },
    titleActiveBorderShow: {
      get() {
        let titleActiveBorderShow = false
        if (this.options.titleActiveBorderShow === undefined) {
          if (Array.isArray(this.options.titleActiveBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.titleActiveBorderWidth.length; i++) {
              if (this.options.titleActiveBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              titleActiveBorderShow = false
            } else {
              titleActiveBorderShow = true
            }
          } else {
            if (this.options.titleActiveBorderWidth) {
              titleActiveBorderShow = true
            } else {
              titleActiveBorderShow = false
            }
          }
        } else {
          titleActiveBorderShow = this.options.titleActiveBorderShow
        }
        return titleActiveBorderShow
      },
      set(newVal) {
        if (newVal && !this.titleActiveBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["titleActiveBorderWidth", "titleActiveBorderShow"], false)
        } else {
          this.$changeOptionsEV(newVal, "titleActiveBorderShow", false)
        }
      }
    },
    titleActiveBorderTypeFlag: {
      get() {
        return this.options.titleActiveBorderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveBorderTypeFlag", false)
      }
    },
    titleActiveBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "titleActiveBorderRadius",
          "titleActiveBorderRadius",
          this.titleActiveBorderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.titleActiveBorderTypeFlag === 2) {
          this.titleActiveBorderTopLeftRadius = newVal
          this.titleActiveBorderTopRightRadius = newVal
          this.titleActiveBorderBottomLeftRadius = newVal
          this.titleActiveBorderBottomRightRadius = newVal
        }
        this.$changeOptionsEV(newVal, "titleActiveBorderRadius", false)
      }
    },
    titleActiveBorderTopLeftRadius: {
      get() {
        return this.options.titleActiveBorderTopLeftRadius
      },
      set(newVal) {
        if (this.titleActiveBorderTypeFlag === 2) {
          this.$changeOptionsEV(
            [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
            [
              "titleActiveBorderTopRightRadius",
              "titleActiveBorderBottomRightRadius",
              "titleActiveBorderBottomLeftRadius",
              "titleActiveBorderTopLeftRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "titleActiveBorderTopLeftRadius", false)
        }
      }
    },
    titleActiveBorderTopRightRadius: {
      get() {
        return this.options.titleActiveBorderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveBorderTopRightRadius", false)
      }
    },
    titleActiveBorderBottomRightRadius: {
      get() {
        return this.options.titleActiveBorderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveBorderBottomRightRadius", false)
      }
    },
    titleActiveBorderBottomLeftRadius: {
      get() {
        return this.options.titleActiveBorderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveBorderBottomLeftRadius", false)
      }
    },
    titleActiveBorderWidth: {
      get() {
        return this.options.titleActiveBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveBorderWidth", false)
      }
    },
    titleActiveBorderStyle: {
      get() {
        return this.options.titleActiveBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveBorderStyle", false)
      }
    },
    titleActiveBorderColor: {
      get() {
        return this.options.titleActiveBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveBorderColor", false)
      }
    },
    titleActiveBorderIsThemeColor: {
      get() {
        return this.options.titleActiveBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveBorderIsThemeColor", false)
      }
    },
    titleActiveTitleIconShow: {
      get() {
        let hasIconSic = false
        if (this.options.titleActiveTitleIconShow === undefined) {
          if (this.titleActiveIconSrc.length > 0) {
            hasIconSic = true
          } else {
            hasIconSic = false
          }
        } else {
          hasIconSic = this.options.titleActiveTitleIconShow
        }
        return hasIconSic
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveTitleIconShow", false)
      }
    },
    titleActiveIconSrc: {
      get() {
        return this.options.titleActiveIconSrc || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveIconSrc", false)
      }
    },
    titleActiveIconType: {
      get() {
        return this.options.titleActiveIconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveIconType", false)
      }
    },
    titleActiveIconWidth: {
      get() {
        return this.options.titleActiveIconWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveIconWidth", false)
      }
    },
    titleActiveIconMargin: {
      get() {
        return this.options.titleActiveIconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveIconMargin", false)
      }
    },
    titleActiveIconColor: {
      get() {
        return this.options.titleActiveIconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveIconColor", false)
      }
    },
    titleActiveIconColorIsThemeColor: {
      get() {
        return this.options.titleActiveIconColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveIconColorIsThemeColor", false)
      }
    },
    titleActiveIconPosition: {
      get() {
        return this.options.titleActiveIconPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveIconPosition", false)
      }
    },
    titleActiveResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titleActiveResInfo", "titleActiveResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleActiveResInfo", false)
      }
    },
    // 子分类样式
    subFilterBackground: {
      get() {
        let background = this.options.subFilterBackground
        if (background && Array.isArray(background) && background.length > 0) {
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.subFilterBgColorIsThemeColor,
            color: this.options.subFilterBgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "subFilterBackground", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterBackground", false)
      }
    },
    subFilterBgColorIsThemeColor: {
      get() {
        return this.options.subFilterBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterBgColorIsThemeColor", false)
      }
    },
    subFilterDialogBackground: {
      get() {
        let background = this.options.subFilterDialogBackground
        if (background && Array.isArray(background) && background.length > 0) {
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.subFilterDialogBgColorIsThemeColor,
            color: "rgba(0,0,0,0.3)"
          }
        ]
        this.$changeOptionsEV(newBackground, "subFilterDialogBackground", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterDialogBackground", false)
      }
    },
    subFilterDialogBgColorIsThemeColor: {
      get() {
        return this.options.subFilterDialogBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterDialogBgColorIsThemeColor", false)
      }
    },
    subFilterBgColor: {
      get() {
        return this.options.subFilterBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterBgColor", false)
      }
    },
    subFilterWidthType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "subFilterWidthType", "subFilterWidthType", "充满")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterWidthType", false)
      }
    },
    subFilterHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "subFilterHeight", "subFilterHeight", 200)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterHeight", false)
      }
    },
    // subFilterWidthAuto: {
    //   get() {
    //     return this.checkAndSetPrimaryVal(this.options, "subFilterWidthAuto", "subFilterWidthAuto", false)
    //   },
    //   set(newVal) {
    //     this.$changeOptionsEV(newVal, "subFilterWidthAuto", false)
    //   }
    // },
    subFilterHeightAuto: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "subFilterHeightAuto", "subFilterHeightAuto", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterHeightAuto", false)
      }
    },
    menuRowContent: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "menuRowContent", "menuRowContent", 3)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "menuRowContent", false)
      }
    },
    filterType: {
      get() {
        const extraConfig = this.subMenuConfig.find(item => item.menuId === this.activeValue)?.extraConfig || {}
        return extraConfig.hasOwnProperty("filterType") ? extraConfig.filterType : "1"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filterType", false)
        const config = {
          name: "oneFilterType",
          desc: "筛选方式",
          isSystem: true,
          group: "默认",
          type: "filterType",
        }
        this.setSubMenuConfig(config, newVal)
      }
    },
    filterBottomHeight: {
      get() {
        return this.options.hasOwnProperty("filterBottomHeight") ? this.options.filterBottomHeight : 50
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filterBottomHeight", false)
      }
    },
    openResetButton: {
      get() {
        return this.options.hasOwnProperty("openResetButton") ? this.options.openResetButton : true
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "openResetButton", false)
      }
    },
    subFilterShowBorder: {
      get() {
        let showBorder = false
        if (this.options.subFilterShowBorder === undefined) {
          if (Array.isArray(this.options.subFilterBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.subFilterBorderWidth.length; i++) {
              if (this.options.subFilterBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.subFilterBorderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
        } else {
          showBorder = this.options.subFilterShowBorder
        }
        return showBorder
      },
      set(newVal) {
        if (newVal && !this.subFilterBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["subFilterBorderWidth", "subFilterShowBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "subFilterShowBorder", false)
        }
      }
    },
    subFilterBorderWidth: {
      get() {
        return this.options.subFilterBorderWidth || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterBorderWidth", false)
      }
    },
    subFilterBorderStyle: {
      get() {
        return this.options.subFilterBorderStyle || "solid"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterBorderStyle", false)
      }
    },
    subFilterBorderColor: {
      get() {
        return this.options.subFilterBorderColor || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterBorderColor", false)
      }
    },
    subFilterBorderIsThemeColor: {
      get() {
        return this.options.subFilterBorderIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterBorderIsThemeColor", false)
      }
    },
    subFilterBorderTypeFlag: {
      get() {
        return this.options.subFilterBorderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterBorderTypeFlag", false)
      }
    },
    subFilterBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "subFilterBorderRadius", "subFilterBorderRadius", this.subFilterBorderTopLeftRadius)
      },
      set(newVal) {
        if (this.subFilterBorderTypeFlag === 2) {
          this.$changeOptionsEV(
            [newVal, newVal, newVal, newVal, newVal],
            [
              "subFilterBorderTopLeftRadius",
              "subFilterBorderTopRightRadius",
              "subFilterBorderBottomLeftRadius",
              "subFilterBorderBottomRightRadius",
              "subFilterBorderRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "subFilterBorderRadius", false)
        }
      }
    },
    subFilterBorderTopLeftRadius: {
      get() {
        return this.options.subFilterBorderTopLeftRadius || 0
      },
      set(newVal) {
        if (this.subFilterBorderTypeFlag === 2) {
          this.$changeOptionsEV(
            [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
            ["subFilterBorderTopRightRadius", "subFilterBorderBottomRightRadius", "subFilterBorderBottomLeftRadius", "subFilterBorderTopLeftRadius"],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "subFilterBorderTopLeftRadius", false)
        }
      }
    },
    subFilterBorderTopRightRadius: {
      get() {
        return this.options.subFilterBorderTopRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterBorderTopRightRadius", false)
      }
    },
    subFilterBorderBottomRightRadius: {
      get() {
        return this.options.subFilterBorderBottomRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterBorderBottomRightRadius", false)
      }
    },
    subFilterBorderBottomLeftRadius: {
      get() {
        return this.options.subFilterBorderBottomLeftRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterBorderBottomLeftRadius", false)
      }
    },
    subFilterPaddingTypeFlag: {
      get() {
        let defaultType = 2
        if (
          ((this.subFilterPaddingTop === this.subFilterPaddingRight) === this.subFilterPaddingLeft) ===
          this.subFilterPaddingBottom
        ) {
          defaultType = 1
        }
        return this.options.subFilterPaddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterPaddingTypeFlag", false)
      }
    },
    subFilterPadding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "subFilterPadding", "subFilterPadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterPadding", false)
      }
    },
    subFilterPaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "subFilterPaddingTop", "subFilterPaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterPaddingTop", false)
      }
    },
    subFilterPaddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "subFilterPaddingRight", "subFilterPaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterPaddingRight", false)
      }
    },
    subFilterPaddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "subFilterPaddingLeft", "subFilterPaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterPaddingLeft", false)
      }
    },
    subFilterPaddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "subFilterPaddingBottom", "subFilterPaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterPaddingBottom", false)
      }
    },
    subFilterBoxShadowColor: {
      get() {
        return this.options.subFilterBoxShadowColor || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterBoxShadowColor", false)
      }
    },
    subFilterOpacity: {
      get() {
        return this.options.subFilterOpacity || 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterOpacity", false)
      }
    },
    subFilterBoxShadowH: {
      get() {
        return this.options.subFilterBoxShadowH || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterBoxShadowH", false)
      }
    },
    subFilterBoxShadowV: {
      get() {
        return this.options.subFilterBoxShadowV || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterBoxShadowV", false)
      }
    },
    subFilterBoxShadowBlur: {
      get() {
        return this.options.subFilterBoxShadowBlur || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterBoxShadowBlur", false)
      }
    },
    subFilterBoxShadowSpread: {
      get() {
        return this.options.subFilterBoxShadowSpread || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterBoxShadowSpread", false)
      }
    },
    subFilterShowMaxWidth: {
      get() {
        return this.options.subFilterShowMaxWidth || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterShowMaxWidth", false)
      }
    },
    subFilterShowMinWidth: {
      get() {
        return this.options.subFilterShowMinWidth || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterShowMinWidth", false)
      }
    },
    subFilterMaxWidthVal: {
      get() {
        return this.options.subFilterMaxWidthVal
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterMaxWidthVal", false)
      }
    },
    subFilterMinWidthVal: {
      get() {
        return this.options.subFilterMinWidthVal
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterMinWidthVal", false)
      }
    },
    subFilterShowMaxHeight: {
      get() {
        return this.options.subFilterShowMaxHeight || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterShowMaxHeight", false)
      }
    },
    subFilterShowMinHeight: {
      get() {
        return this.options.subFilterShowMinHeight || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterShowMinHeight", false)
      }
    },
    subFilterMaxHeightVal: {
      get() {
        return this.options.subFilterMaxHeightVal
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterMaxHeightVal", false)
      }
    },
    subFilterMinHeightVal: {
      get() {
        return this.options.subFilterMinHeightVal
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "subFilterMinHeightVal", false)
      }
    },
    contentHasLimit: {
      get() {
        return this.options.contentHasLimit
      },
      set(val) {
        this.$changeOptionsEV(val, "contentHasLimit", false)
      }
    },
    contentHasLimitRadio: {
      get() {
        const defaultRadio = this.model === "filter" ? "字数" : "行数"
        return this.checkAndSetPrimaryVal(this.options, "contentHasLimitRadio", "contentHasLimitRadio", defaultRadio)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "contentHasLimitRadio", false)
      }
    },
    textLimitWords: {
      get() {
        return this.options.textLimitWords || 4
      },
      set(val) {
        this.$changeOptionsEV(val, "textLimitWords", false)
      }
    },
    defaultOpacity: {
      get() {
        return this.options.defaultOpacity || 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultOpacity", false)
      }
    },
    // 已选标签
    labelAlignmentType: {
      get() {
        return this.options.labelAlignmentType || "left"
      },
      set(val) {
        this.$changeOptionsEV(val, "labelAlignmentType", false)
      }
    },
    labelLineMargin: {
      get() {
        return this.options.labelLineMargin || 10
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelLineMargin", false)
      }
    },
    labelColumnMargin: {
      get() {
        return this.options.labelColumnMargin || 10
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelColumnMargin", false)
      }
    },
    labelBoxBgColorIsThemeColor: {
      get() {
        return this.options.labelBoxBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxBgColorIsThemeColor", false)
      }
    },
    labelBoxBgColor: {
      get() {
        return this.options.labelBoxBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxBgColor", false)
      }
    },
    labelBoxBackground: {
      get() {
        let background = this.options.labelBoxBackground
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.labelBoxBackground
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.labelBoxBgColorIsThemeColor,
            color: ""
          }
        ]
        this.$changeOptionsEV(newBackground, "labelBoxBackground", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxBackground", false)
      }
    },
    labelBoxShowBorder: {
      get() {
        let showBorder = false
        if (this.options.labelBoxShowBorder === undefined) {
          if (Array.isArray(this.options.labelBoxBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.labelBoxBorderWidth.length; i++) {
              if (this.options.labelBoxBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.labelBoxBorderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
        } else {
          showBorder = this.options.labelBoxShowBorder
        }
        return showBorder
      },
      set(newVal) {
        if (newVal && !this.labelBoxBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["labelBoxBorderWidth", "labelBoxShowBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "labelBoxShowBorder", false)
        }
      }
    },
    labelBoxBorderWidth: {
      get() {
        return this.options.labelBoxBorderWidth || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxBorderWidth", false)
      }
    },
    labelBoxBorderStyle: {
      get() {
        return this.options.labelBoxBorderStyle || "solid"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxBorderStyle", false)
      }
    },
    labelBoxBorderColor: {
      get() {
        return this.options.labelBoxBorderColor || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxBorderColor", false)
      }
    },
    labelBoxBorderIsThemeColor: {
      get() {
        return this.options.labelBoxBorderIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxBorderIsThemeColor", false)
      }
    },
    labelBoxBorderTypeFlag: {
      get() {
        return this.options.labelBoxBorderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxBorderTypeFlag", false)
      }
    },
    labelBoxBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelBoxBorderRadius", "labelBoxBorderRadius", this.labelBoxBorderTopLeftRadius)
      },
      set(newVal) {
        if (this.labelBoxBorderTypeFlag === 2) {
          this.$changeOptionsEV(
            [newVal, newVal, newVal, newVal, newVal],
            [
              "labelBoxBorderTopLeftRadius",
              "labelBoxBorderTopRightRadius",
              "labelBoxBorderBottomLeftRadius",
              "labelBoxBorderBottomRightRadius",
              "labelBoxBorderRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "labelBoxBorderRadius", false)
        }
      }
    },
    labelBoxBorderTopLeftRadius: {
      get() {
        return this.options.labelBoxBorderTopLeftRadius || 0
      },
      set(newVal) {
        if (this.labelBoxBorderTypeFlag === 2) {
          this.$changeOptionsEV(
            [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
            ["labelBoxBorderTopRightRadius", "labelBoxBorderBottomRightRadius", "labelBoxBorderBottomLeftRadius", "labelBoxBorderTopLeftRadius"],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "labelBoxBorderTopLeftRadius", false)
        }
      }
    },
    labelBoxBorderTopRightRadius: {
      get() {
        return this.options.labelBoxBorderTopRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxBorderTopRightRadius", false)
      }
    },
    labelBoxBorderBottomRightRadius: {
      get() {
        return this.options.labelBoxBorderBottomRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxBorderBottomRightRadius", false)
      }
    },
    labelBoxBorderBottomLeftRadius: {
      get() {
        return this.options.labelBoxBorderBottomLeftRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxBorderBottomLeftRadius", false)
      }
    },
    labelBoxPaddingTypeFlag: {
      get() {
        let defaultType = 2
        if (
          ((this.labelBoxPaddingTop === this.labelBoxPaddingRight) === this.labelBoxPaddingLeft) ===
          this.labelBoxPaddingBottom
        ) {
          defaultType = 1
        }
        return this.options.labelBoxPaddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxPaddingTypeFlag", false)
      }
    },
    labelBoxPadding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelBoxPadding", "labelBoxPadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxPadding", false)
      }
    },
    labelBoxPaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelBoxPaddingTop", "labelBoxPaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxPaddingTop", false)
      }
    },
    labelBoxPaddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelBoxPaddingRight", "labelBoxPaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxPaddingRight", false)
      }
    },
    labelBoxPaddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelBoxPaddingLeft", "labelBoxPaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxPaddingLeft", false)
      }
    },
    labelBoxPaddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelBoxPaddingBottom", "labelBoxPaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxPaddingBottom", false)
      }
    },
    labelBoxBoxShadowColor: {
      get() {
        return this.options.labelBoxBoxShadowColor || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxBoxShadowColor", false)
      }
    },
    labelBoxOpacity: {
      get() {
        return this.options.labelBoxOpacity || 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxOpacity", false)
      }
    },
    labelBoxBoxShadowH: {
      get() {
        return this.options.labelBoxBoxShadowH || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxBoxShadowH", false)
      }
    },
    labelBoxBoxShadowV: {
      get() {
        return this.options.labelBoxBoxShadowV || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxBoxShadowV", false)
      }
    },
    labelBoxBoxShadowBlur: {
      get() {
        return this.options.labelBoxBoxShadowBlur || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxBoxShadowBlur", false)
      }
    },
    labelBoxBoxShadowSpread: {
      get() {
        return this.options.labelBoxBoxShadowSpread || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxBoxShadowSpread", false)
      }
    },
    showLabelScorll: {
      get() {
        return this.options.hasOwnProperty("showLabelScorll") ? this.options.showLabelScorll : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showLabelScorll", false)
      }
    },
    labelBoxHeight: {
      get() {
        return this.options.labelBoxHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxHeight", false)
      }
    },
    labelBoxHeightAuto: {
      get() {
        return this.options.labelBoxHeightAuto
      },
      set(newVal) {
        console.log('newVal :>>',newVal);

        this.$changeOptionsEV(newVal, "labelBoxHeightAuto", false)
      }
    },

    labelFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelFontFamily", "labelFontFamily", "sans-serif")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelFontFamily", false)
      }
    },
    labelFontSize: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelFontSize", "labelFontSize", 16)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelFontSize", false)
      }
    },
    labelFontWeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelFontWeight", "labelFontWeight", 400)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelFontWeight", false)
      }
    },
    labelFontStyle: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelFontStyle", "labelFontStyle", "normal")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelFontStyle", false)
      }
    },
    labelTextDecoration: {
      get() {
        return this.options.labelTextDecoration || "none"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelTextDecoration", false)
      }
    },
    labelLineHeight: {
      get() {
        return this.options.labelLineHeight || 24
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelLineHeight", false)
      }
    },
    labelLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelLineHeightType", "labelLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelLineHeightType", false)
      }
    },
    labelLetterSpacing: {
      get() {
        return this.options.labelLetterSpacing || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelLetterSpacing", false)
      }
    },
    labelTextIsThemeColor: {
      get() {
        return this.options.labelTextIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelTextIsThemeColor", false)
      }
    },
    labelColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelColor", "labelColor", "7B7B7D")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelColor", false)
      }
    },
    labelTextAlign: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelTextAlign", "labelTextAlign", "left")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelTextAlign", false)
      }
    },
    labelArrangement() {
      return this.options.labelArrangement
    },
    labelWritingMode: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelWritingMode", "labelWritingMode", "horizontal-tb")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelWritingMode", false)
      }
    },
    labelArrangementOrder: {
      get() {
        return {
          label: "竖排文字",
          _class: "icon-portal-text-down1",
          isActive: this.labelWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.labelWritingMode = val
      }
    },
    labelContentHasLimit: {
      get() {
        return this.options.labelContentHasLimit
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelContentHasLimit", false)
      }
    },
    labelTextLimitWords: {
      get() {
        return this.options.labelTextLimitWords || 4
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelTextLimitWords", false)
      }
    },
    labelBgColorIsThemeColor: {
      get() {
        return this.options.labelBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBgColorIsThemeColor", false)
      }
    },
    labelIconSrc: {
      get() {
        return this.options.labelIconSrc || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelIconSrc", false)
      }
    },
    labelIconType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelIconType", "labelIconType", "icon")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelIconType", false)
      }
    },
    labelIconWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelIconWidth", "labelIconWidth", 12)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelIconWidth", false)
      }
    },
    labelIconMargin: {
      get() {
        return this.options.labelIconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelIconMargin", false)
      }
    },
    labelIconColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelIconColor", "labelIconColor", "#999999")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelIconColor", false)
      }
    },
    labelIconColorIsThemeColor: {
      get() {
        return this.options.labelIconColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelIconColorIsThemeColor", false)
      }
    },
    labelIconPosition: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelIconPosition", "labelIconPosition", "right")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelIconPosition", false)
      }
    },
    labelResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelResInfo", "labelResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelResInfo", false)
      }
    },
    labelBgColor: {
      get() {
        return this.options.labelBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBgColor", false)
      }
    },
    labelBackground: {
      get() {
        let background = this.options.labelBackground
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.labelBackground
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.labelBgColorIsThemeColor,
            color: this.labelBgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "labelBackground", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBackground", false)
      }
    },
    labelShowBorder: {
      get() {
        let showBorder = false
        if (this.options.labelShowBorder === undefined) {
          if (Array.isArray(this.options.labelBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.labelBorderWidth.length; i++) {
              if (this.options.labelBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.labelBorderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
        } else {
          showBorder = this.options.labelShowBorder
        }
        return showBorder
      },
      set(newVal) {
        if (newVal && !this.labelBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["labelBorderWidth", "labelShowBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "labelShowBorder", false)
        }
      }
    },
    labelBorderWidth: {
      get() {
        return this.options.labelBorderWidth || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBorderWidth", false)
      }
    },
    labelBorderStyle: {
      get() {
        return this.options.labelBorderStyle || "solid"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBorderStyle", false)
      }
    },
    labelBorderColor: {
      get() {
        return this.options.labelBorderColor || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBorderColor", false)
      }
    },
    labelBorderIsThemeColor: {
      get() {
        return this.options.labelBorderIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBorderIsThemeColor", false)
      }
    },
    labelBorderTypeFlag: {
      get() {
        return this.options.labelBorderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBorderTypeFlag", false)
      }
    },
    labelBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelBorderRadius", "labelBorderRadius", this.labelBorderTopLeftRadius)
      },
      set(newVal) {
        if (this.labelBorderTypeFlag === 2) {
          this.$changeOptionsEV(
            [newVal, newVal, newVal, newVal, newVal],
            [
              "labelBorderTopLeftRadius",
              "labelBorderTopRightRadius",
              "labelBorderBottomLeftRadius",
              "labelBorderBottomRightRadius",
              "labelBorderRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "labelBorderRadius", false)
        }
      }
    },
    labelBorderTopLeftRadius: {
      get() {
        return this.options.labelBorderTopLeftRadius || 0
      },
      set(newVal) {
        if (this.labelBorderTypeFlag === 2) {
          this.$changeOptionsEV(
            [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
            ["labelBorderTopRightRadius", "labelBorderBottomRightRadius", "labelBorderBottomLeftRadius", "labelBorderTopLeftRadius"],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "labelBorderTopLeftRadius", false)
        }
      }
    },
    labelBorderTopRightRadius: {
      get() {
        return this.options.labelBorderTopRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBorderTopRightRadius", false)
      }
    },
    labelBorderBottomRightRadius: {
      get() {
        return this.options.labelBorderBottomRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBorderBottomRightRadius", false)
      }
    },
    labelBorderBottomLeftRadius: {
      get() {
        return this.options.labelBorderBottomLeftRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBorderBottomLeftRadius", false)
      }
    },
    labelPaddingTypeFlag: {
      get() {
        let defaultType = 2
        if (
          ((this.labelPaddingTop === this.labelPaddingRight) === this.labelPaddingLeft) ===
          this.labelPaddingBottom
        ) {
          defaultType = 1
        }
        return this.options.labelPaddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelPaddingTypeFlag", false)
      }
    },
    labelPadding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelPadding", "labelPadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelPadding", false)
      }
    },
    labelPaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelPaddingTop", "labelPaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelPaddingTop", false)
      }
    },
    labelPaddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelPaddingRight", "labelPaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelPaddingRight", false)
      }
    },
    labelPaddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelPaddingLeft", "labelPaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelPaddingLeft", false)
      }
    },
    labelPaddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "labelPaddingBottom", "labelPaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelPaddingBottom", false)
      }
    },
    labelBoxShadowColor: {
      get() {
        return this.options.labelBoxShadowColor || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxShadowColor", false)
      }
    },
    labelOpacity: {
      get() {
        return this.options.labelOpacity || 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelOpacity", false)
      }
    },
    labelBoxShadowH: {
      get() {
        return this.options.labelBoxShadowH || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxShadowH", false)
      }
    },
    labelBoxShadowV: {
      get() {
        return this.options.labelBoxShadowV || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxShadowV", false)
      }
    },
    labelBoxShadowBlur: {
      get() {
        return this.options.labelBoxShadowBlur || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxShadowBlur", false)
      }
    },
    labelBoxShadowSpread: {
      get() {
        return this.options.labelBoxShadowSpread || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelBoxShadowSpread", false)
      }
    },
    labelWidthAuto: {
      get() {
        if (this.options.labelWidthAuto) {
          this.labelContentHasLimit = false
        } else {
          this.labelContentHasLimit = true
        }
        return this.options.hasOwnProperty("labelWidthAuto") ? this.options.labelWidthAuto : true
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelWidthAuto", false)
      }
    },
    labelHeightAuto: {
      get() {
        return this.options.hasOwnProperty("labelHeightAuto") ? this.options.labelHeightAuto : true
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelHeightAuto", false)
      }
    },
    labelWidth: {
      get() {
        return this.options.labelWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelWidth", false)
      }
    },
    labelHeight: {
      get() {
        return this.options.labelHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "labelHeight", false)
      }
    },
    openSelectedStatus: {
      get() {
        return this.options.hasOwnProperty("openSelectedStatus") ? this.options.openSelectedStatus : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "openSelectedStatus", false)
      }
    },
    activeValue: {
      get() {
        return this.options.activeValue
      },
      set(val) {
        this.$changeOptionsEV(val, "activeValue", false)
      }
    },
    buttonType: {
      get() {
        return this.options.buttonType
      },
      set(val) {
        this.$changeOptionsEV(val, "buttonType", false)
      }
    },
    buttonShow: {
      get() {
        return this.options.hasOwnProperty("buttonShow") ? this.options.buttonShow : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonShow", false)
      }
    },
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
    /* 是否在自动布局中 */
    this.isInAutoLayout = isInAutoLayout(this.$store.state[this.request_prefix], this.ids, this.options)
  },
  methods: {
    getFocus(event) {
      event.currentTarget.select()
    },
    addBoxshadow(prefix) {
      if (!Array.isArray(this[`${prefix}oxShadowH`])) {
        this[`${prefix}oxShadowH`] = [this[`${prefix}oxShadowH`]]
        this[`${prefix}oxShadowV`] = [this[`${prefix}oxShadowV`]]
        this[`${prefix}oxShadowBlur`] = [this[`${prefix}oxShadowBlur`]]
        this[`${prefix}oxShadowSpread`] = [this[`${prefix}oxShadowSpread`]]
        this[`${prefix}oxShadowColor`] = [this[`${prefix}oxShadowColor`]]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this[`${prefix}oxShadowH`]))
      let boxShadowV = JSON.parse(JSON.stringify(this[`${prefix}oxShadowV`]))
      let boxShadowBlur = JSON.parse(JSON.stringify(this[`${prefix}oxShadowBlur`]))
      let boxShadowSpread = JSON.parse(JSON.stringify(this[`${prefix}oxShadowSpread`]))
      let boxShadowColor = JSON.parse(JSON.stringify(this[`${prefix}oxShadowColor`]))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this[`${prefix}oxShadowH`] = boxShadowH
      this[`${prefix}oxShadowV`] = boxShadowV
      this[`${prefix}oxShadowBlur`] = boxShadowBlur
      this[`${prefix}oxShadowSpread`] = boxShadowSpread
      this[`${prefix}oxShadowColor`] = boxShadowColor
    },
    changeFilter(val, flag) {
      this.curFilter = val
      this.$emit("update:statusOpened", flag)
      this.$emit("update:styleOpened", !flag)
      this.$emit("onHideHeader", flag)
    },
    changeButtonFilter(val, flag) {
      this.changeFilter(0,false)
      this.buttonType = val
      this.$emit("update:statusOpened", flag)
      this.$emit("update:styleOpened", !flag)
      this.$emit("onHideHeader", flag)
    },
    changeRowLen(flag) {
      if (this.menuRowContent === 1 && flag === 0) {
        return
      }
      if (this.menuRowContent === 10 && flag === 1) {
        return
      }
      this.menuRowContent = flag === 0 ? this.menuRowContent - 1 : this.menuRowContent + 1
    },
    setSubMenuConfig(config, value) {
      const index = this.subMenuConfig.findIndex(item => item.menuId === this.activeValue)
      const {name, type} = config
      let extraConfig = {}
      extraConfig[type] = value
      const newSubMenuConfig = JSON.parse(JSON.stringify(this.subMenuConfig))
      if (index === -1) {
        newSubMenuConfig.push({styleId: 1, extraConfig: extraConfig, menuId: this.activeValue})
      } else {
        if (newSubMenuConfig[index].extraConfig) newSubMenuConfig[index].extraConfig[type] = value
        else newSubMenuConfig[index].extraConfig = extraConfig
      }
      this.subMenuConfig = newSubMenuConfig
    }
  }
})
</script>

<style scoped lang="scss">
.arrange-direction::v-deep .slider-label {
  width: 42px;
}
.custom-title-color {
  width: calc(100% - 76px);
}

.multiFilter-options-setting .width-type-tab ::v-deep .el-tabs .el-tabs__content {
  display: none;
}
.multiFilter-options-setting .width-type-tab ::v-deep .el-tabs .el-tabs__header {
  margin-left: 0;
  margin-right: 0;
}
.multiFilter-options-setting .tips-btn {
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 14px;
  color: var(--thirdTextColor);
  margin-left: 2px;
  cursor: pointer;
  border-radius: 4px;
}
.multiFilter-options-setting .tips-btn:hover {
  color: var(--themeColor);
}
::v-deep .explainDialog {
  width: 700px;
}
::v-deep .explainDialog .el-dialog__body {
  padding: 16px 24px 24px;
  color: var(--textColor);
}

::v-deep .explainDialog .tips span {
  font-weight: 600;
}

::v-deep .explainDialog .box {
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  height: 366px;
  background: #fafafa;
  margin-top: 16px;
}
::v-deep .filter-state-set .el-tabs__content {
  padding-bottom: 0;
}
.navBox {
  height: 32px;
  padding: 4px 4px 4px 12px;
  border-radius: 4px;
  background: var(--inputBg);
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:hover {
    background: var(--inputNuberHoverThemeBgColor);
  }
  .navTitle {
    font-size: 13px;
    font-weight: 600;
    color: var(--textColor);
  }
  .navLabel {
    color: var(--thirdTextColor);
    display: flex;
  }
  .navIcon {
    font-size: 20px;
  }
  &:hover {
    cursor: pointer;
  }
}
.navBackBox {
  height: 38px;
  padding-left: 12px;
  display: flex;
  gap: 4px;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
  .navBackIcon {
    font-size: 24px;
  }
  .navBackTitle {
    font-size: 14px;
    font-weight: 600;
    color: var(--textColor);
  }
}
.checked-label {
  padding: 8px 12px 16px 12px;
}
.option-choose-container {
  border-radius: 4px;
  padding: 5px 12px;
  background-color: var(--cardBgColor);
  border: 1px solid var(--sliderBackGround);
  margin-top: 8px;
}
.row-set {

  .btn-wrapper {
    flex: 1;
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 6px 0;
    font-size: 0;
    margin-left: 12px;

    .num-btn {
      display: inline-block;
      width: 50%;
      text-align: center;
      line-height: 20px;
      font-size: 13px;
      cursor: pointer;
      color: var(--subTextColor);

      &:not(:last-child) {
        border-right: 1px solid var(--sliderBackGround);
      }

      &:not(.disabled):hover {
        color: var(--themeColor);
      }

      &.disabled {
        color: var(--borderColorSeven);
        cursor: not-allowed;
      }
    }
  }
}
  .bb1b9{
    border-bottom: 1px solid #E9E9E9;
  }
  .pb8{
    padding-bottom: 8px;
  }
</style>
